import { useEffect, useRef, useState } from "react";
import axios from "axios";
import "../src/index.css";
import "material-symbols";
import $, { event } from "jquery";
import Draggable from "react-draggable";
import person from "./Asset/images/149071.png";
import crmlogo from "./Asset/images/crm2.png";
import statusLogo from "./Asset/images/149071.png";
import logo from "./Asset/images/Inaipi_Logo-1.2.png";
import inaipilogo from "./Asset/images/Inaipi_Logo-1.2.png";
import inaipiLogo from "./Asset/images/Inaipi_Logo-1.2.png";
import { browserName } from "react-device-detect";
import io from "socket.io-client";
import SockJS from "sockjs-client";
import { Stomp } from "stompjs/lib/stomp";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BrowserPhoneSIP from "./utils/BrowserPhoneSIP";

export const toastStyle = {
  position: "top-right",
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
};

export const SetTimerComponent = () => {
  const intervalRef = useRef(null);
  const [time, setTime] = useState({
    sec: 0,
    min: 0,
    hr: 0,
  });

  const updateTimer = () => {
    setTime((prev) => {
      let { sec, min, hr } = prev;

      sec += 1;
      if (sec >= 60) {
        sec = 0;
        min += 1;
      }
      if (min >= 60) {
        min = 0;
        hr += 1;
      }

      return { sec, min, hr };
    });
  };

  const startsTimer = () => {
    reset();
    if (!intervalRef.current) {
      intervalRef.current = setInterval(updateTimer, 1000);
    }
  };

  const pauseTimer = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const reset = () => {
    pauseTimer();
    setTime({ sec: 0, min: 0, hr: 0 });
  };

  return { startsTimer, pauseTimer, reset, time };
};

const App = () => {
  // "https://accounts.zoho.in/oauth/v2/auth?scope=ZohoCRM.modules.ALL,ZohoCRM.contacts.CREATE,ZohoCRM.modules.Calls.CREATE,ZohoCRM.modules.READ,ZohoCRM.contacts.READ,PhoneBridge.call.log,PhoneBridge.zohoone.search,ZohoCRM.modules.ALL&client_id=1000.YZJ9EP4ED6Q94N0AEI9K14JOF5IVWT&redirect_uri=https://utils.ntt.inaipi.ae/zohovoice/callback/997bcb75-50f0-476e-be86-f834da6ec33e&response_type=code&access_type=offline";
  // const AvcUrl = "https://utils.ntt.inaipi.ae/voice/voicechat";
  // const VoiceDomainName = "ipo.inaipi.in";
  const authorizeRoute = "https://accounts.zoho.com/oauth/v2/auth?scope=PhoneBridge.call.log,PhoneBridge.zohoone.search&client_id=1000.YZJ9EP4ED6Q94N0AEI9K14JOF5IVWT&redirect_uri=https://utils.ntt.inaipi.ae/zohovoice/callback/997bcb75-50f0-476e-be86-f834da6ec33e&response_type=code&access_type=offline"
  const callNotifyUrl = "https://utils.ntt.inaipi.ae/zohovoice";
  const AvcUrl = "https://avayaucj.inaipi.me/voicev2/voicechat";
  const BaseURL = "https://gateway.ntt.inaipi.ae/v1";
  const logoutUrl = "https://dcc.ntt.inaipi.ae/v1";
  const SocketUrl = "https://utils.ntt.inaipi.ae";
  const VoiceDomainName = "ucd.inaipi.me";
  const tenantId = "997bcb75-50f0-476e-be86-f834da6ec33e";
  let avayaPlatform = "AACC";

  const urlParams = new URLSearchParams(window.location.search);
  const tenantIDUrl = urlParams.get("tenantID");
  const code = urlParams.get("code");
  const location = urlParams.get("location");

  const getTimer = SetTimerComponent();
  let agentLoginTerminalId = localStorage.getItem("agentLoginTerminalId") || "";
  let agentUsername = localStorage.getItem("agentUsername") || "";
  const loggedInAgent = JSON.parse(localStorage.getItem("avayaLogin")) || {};
  const [isShown, setIsShown] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [eye, setEye] = useState(false);
  const [loginSpinner, setLoginSpinner] = useState(false);
  const [loginPage, setLoginPage] = useState(!localStorage.getItem("dashboard"));
  const [Dashboard, setDashboard] = useState(!!localStorage.getItem("dashboard"));
  const [routeScreen, setRouteScreen] = useState("");
  const [input, setInput] = useState("");
  const [dailedNumber, setDailedNumber] = useState("");
  const [agenttransfernum, setAgenttransfernum] = useState("");
  const [agentconfnum, setAgentconfnum] = useState("");
  const [storedAgentNum, setStoredAgentNum] = useState("");
  const [storedConferAgentNum, setStoredConferAgentNum] = useState("");
  const [callLogEntries, setCallLogEntries] = useState([]);
  const [showNotification, setShowNotification] = useState(false);
  const [isModelOpen, setModelOpen] = useState(false);
  const [isModelOpen2, setModelOpen2] = useState(false);
  const [isModelOpen3, setModelOpen3] = useState(false);
  const [isAuthorizeOpen, setIsAuthorizeOpen] = useState(false);
  const [isModalOpenLogout, setModelOpenLogout] = useState(false);
  const [userid, setUserId] = useState("");
  const [userStatus, setUserStatus] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(
    localStorage.getItem("Status") || "Ready"
  );

  // Asterisk SIP client refs and state
  const asteriskClient = useRef(null);
  const currentCall = useRef(null);
  const socketRef = useRef(null);
  const [serverType, setServerType] = useState("aacc"); // "asterisk" or "aacc"

  // Determine serverType based on voiceType from backend
  useEffect(() => {
    const avayaLogin = JSON.parse(localStorage.getItem("avayaLogin") || "{}");
    const voiceType = avayaLogin?.voiceRecord?.voiceType;

    if (voiceType === "ACR" || voiceType === "ASTERISK") {
      // console.log("🔧 Detected ACR/ASTERISK voice type, setting serverType to asterisk");
      setServerType("asterisk");
    } else if (voiceType === "AACC" || voiceType === "ACCS") {
      // console.log("🔧 Detected AACC/ACCS voice type, setting serverType to aacc");
      setServerType("aacc");
    } else {
       // console.log("🔧 Default voice type, setting serverType to asterisk");
      setServerType("asterisk");
    }
  }, [loggedInAgent]);

  // Helper function to check if current voice type is Asterisk
  const isAsteriskVoiceType = () => {
    try {
      const avayaLogin = JSON.parse(localStorage.getItem("avayaLogin") || "{}");
      const voiceType = avayaLogin?.voiceRecord?.voiceType;
      // console.log("🔍 isAsteriskVoiceType - checking voiceType from localStorage:", voiceType);

      return voiceType === "ACR";
    } catch (error) {
      // console.error("Error reading voiceType from localStorage:", error);
      return false;
    }
  };

  // Helper function to get the correct "from" number based on voice type
  const getFromNumber = () => {
    try {
      const avayaLogin = JSON.parse(localStorage.getItem("avayaLogin") || "{}");
      const voiceType = avayaLogin?.voiceRecord?.voiceType;

      if (voiceType === "ACR") {
        // For Asterisk, use avayaUserName (the registered extension)
        return avayaLogin?.voiceRecord?.avayaUserName || localStorage.getItem("agentLoginTerminalId") || "";
      } else {
        // For AACC/ACCS, use agentLoginTerminalId
        return localStorage.getItem("agentLoginTerminalId") || "";
      }
    } catch (error) {
      // console.error("Error getting from number:", error);
      return localStorage.getItem("agentLoginTerminalId") || "";
    }
  };

  const formatTime = (hr, min, sec, storageKey = "formattedTime") => {
    const h = hr.toString().padStart(2, "0");
    const m = min.toString().padStart(2, "0");
    const s = sec.toString().padStart(2, "0");
    const totalSeconds = (hr * 3600) + (min * 60) + sec;
    localStorage.setItem(storageKey, totalSeconds);
    return `${h}:${m}:${s}`;
  };

  const openModal = () => {
    setModelOpen(true);
  };
  const closeModal = () => {
    setModelOpen(false);
  };

  const openValidNumDiv = () => {
    setModelOpen2(true);
  };
  const closeValidNumDiv = () => {
    setModelOpen2(false);
  };

  const openLoginFailDiv = () => {
    setModelOpen3(true);
  };
  const closeLoginFailedDiv = () => {
    setModelOpen3(false);
  };

  const openAuthorizeDiv = () => {
    setIsAuthorizeOpen(true);
  };
  const closeIaAuthorizeDiv = () => {
    setIsAuthorizeOpen(false);
  };

  const handleButtonClick = (value) => {
    setInput((prevInput) => prevInput + value);
  };

  const handleClear = () => {
    setInput((prevInput) => prevInput.slice(0, -1));
  };

  const handleNumberClick = (newNumber) => {
    setDailedNumber((currentNumber) => {
      if (currentNumber.length < 15) {
        return `${currentNumber}${newNumber}`;
      }
      return currentNumber;
    });
  };

  const handleSignout = async () => {
    await axios
      .post(
        logoutUrl + "/users/logout/" + userid,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: tenantId,
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setModelOpenLogout(false);
        } else {
          setModelOpenLogout(false);
        }
      })
      .catch((err) => { });
  };

  // third logout calling //
  const logout = async () => {
    let data = JSON.parse(localStorage.getItem("avayaLogin"));
    let userID = data.user_id;

    await axios
      .post(
        logoutUrl + "/users/logout/" + userID,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: tenantId,
          },
        }
      )
      .then((res) => { })
      .catch((error) => {
        // console.log("logout_error", error);
      });
  };
  // second logout calling //
  const logoutByDomainSecond = () => {
    // Skip AACC logout for Asterisk
    if (isAsteriskVoiceType()) {
      // console.log("⏭️ Skipping AvcUrl API for Asterisk - logoutByDomainSecond");

      // Disconnect Asterisk client before logging out
      if (asteriskClient.current) {
        // console.log("🔌 Disconnecting Asterisk SIP client during logout");
        try {
          BrowserPhoneSIP.disconnect();
        } catch (error) {
          // console.warn("⚠️ Error disconnecting Asterisk during logout:", error);
        }
        asteriskClient.current = null;
        currentCall.current = null;
      }

      // Call the common logout directly
      logout();
      setTimeout(() => {
        setLoginPage(true);
        setDashboard(false);
        ["Status", "currentPage", "dashboard", "agentUsername", "agentLoginTerminalId", "ssoToken", "callType", "callingDeviceID", "contactId", "calledDeviceID", "avayaLogin", "access_token_cognicx", "CallerId", "startTime", "formattedTime", "dailedNumber", "VoiceStatusLastApiCallTime"].forEach(localStorage.removeItem.bind(localStorage));
      }, 1000);
      return;
    }

    let ssToken = localStorage.getItem("ssoToken") || "";
    let agentUsername = localStorage.getItem("agentUsername");
    axios
      .post(
        AvcUrl + "/voice/cct/logout?username=" + agentUsername,
        {},
        {
          headers: {
            ssoToken: ssToken,
          },
        }
      )
      .then((res) => {
        if (res.data.status === "OK") {
          // console.log("logout_second");
          logout();
          setTimeout(() => {
            setLoginPage(true);
            setDashboard(false);
            ["Status", "currentPage", "dashboard", "agentUsername", "agentLoginTerminalId", "ssoToken", "callType", "callingDeviceID", "contactId", "calledDeviceID", "avayaLogin", "access_token_cognicx", "CallerId", "startTime", "formattedTime", "dailedNumber", "VoiceStatusLastApiCallTime"].forEach(localStorage.removeItem.bind(localStorage));
           // window.location.reload();
          }, 1000);
        }
      })
      .catch((err) => {
        // console.error(err);
      });
  };
  // first logout calling //
  const logoutByDomainFirst = () => {
    // Skip AACC logout for Asterisk
    if (isAsteriskVoiceType()) {
      // console.log("⏭️ Skipping AvcUrl API for Asterisk - logoutByDomainFirst");
      // Call the next logout step directly
      logoutByDomainSecond();
      return;
    }

    let ssToken = localStorage.getItem("ssoToken");
    let agentLoginTerminalId = localStorage.getItem("agentLoginTerminalId");
    axios
      .post(
        AvcUrl +
        `/voice/cct/agent/${agentLoginTerminalId}/logout/${agentLoginTerminalId}`,
        {},
        {
          headers: {
            ssoToken: ssToken,
          },
        }
      )
      .then((res) => {
        if (res.data.status === "OK") {
          // console.log("logout_first");
          logoutByDomainSecond();
        } else {
          setLoginPage(true);
          setDashboard(false);
        }
      })
      .catch((error) => {
        // console.error(error);
      });
  };

  //  login functionalities //
  const loginByDcc = async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const tenantID = urlParams.get("tenantID");
      const code = urlParams.get("code");
      const location = urlParams.get("location");

      setLoginSpinner(true);

      const res = await axios.post(
        BaseURL + "/users/login",
        { email: username, pass: password },
        {
          headers: {
            "Content-Type": "application/json",
            tenantId: tenantId,
          },
        }
      );

      setLoginPage(true);

      if (res.data.status) {
        localStorage.setItem("avayaLogin", JSON.stringify(res.data.user));
        localStorage.setItem("access_token_cognicx", res.data.access_token_cognicx);

        // Detect voice type and initialize appropriate client
        const avayaLogin = JSON.parse(localStorage.getItem("avayaLogin") || "{}");
        const voiceType = avayaLogin?.voiceRecord?.voiceType;

        if (voiceType === "ACR" || voiceType === "ASTERISK") {
          // console.log("🔧 Detected ACR/ASTERISK voice type after login");
          setServerType("asterisk");
          // Initialize Asterisk SIP client
          // console.log("📞 Initializing Asterisk client after login...");
          initializeAsteriskClient();
          // Set dashboard localStorage for Asterisk (since loginByDomain is skipped)
          localStorage.setItem("dashboard", true);
        } else if (voiceType === "AACC" || voiceType === "ACCS") {
          // console.log("🔧 Detected AACC/ACCS voice type after login");
          setServerType("aacc");
          // Initialize AACC client
          await loginByDomain();
        } else {
          // console.log("⚠️ Unknown voice type, defaulting to Asterisk");
          setServerType("asterisk");
          initializeAsteriskClient();
          // Set dashboard localStorage for Asterisk (since loginByDomain is skipped)
          localStorage.setItem("dashboard", true);
        }

        await logInZoho();

        setModelOpenLogout(false);
        setLoginPage(false);
        setDashboard(true);

        if (tenantID && code) {
          openAuthorizeDiv();
        } else {
          setTimeout(() => {
           // window.location.reload();
          }, 1000);
        }
      } else {
        toast.error(res.data.message, toastStyle);

        if (res.data.message === "User Already Login") {
          setUserId(res.data.user_id);
          setModelOpenLogout(true);
        } else {
          setModelOpenLogout(false);
        }
      }
    } catch (err) {
      // console.error("Login Error:", err);
    } finally {
      setLoginSpinner(false);
    }
  };

  const logInZoho = async () => {
    let data = JSON.parse(localStorage.getItem("avayaLogin"));
    let userID = data ? data.user_id : null;
    let emailId = data ? data.email : null;
    const role = emailId && emailId.startsWith("admin") ? "admin" : "agent";

    if (!userID || !tenantIDUrl || !code) {
      try {
        const response = await axios.post(
          `${callNotifyUrl}/channel/authorize`,
          { userId: userID, emailId, code: code, role: role,location:location },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
              "Content-Type": "application/json",
              tenantid: tenantIDUrl || tenantId,
            },
          }
        );

        if (response.data.status === true && response.data.authUrl) {
          window.open(response.data.authUrl, "_blank");
        }
      } catch (error) {
        // console.error("Error during authorization:", error);
      }
      return;
    }

    try {
      const res = await axios.post(
        `${callNotifyUrl}/channel/authorize`,
        { userId: userID, emailId, code: code, role: role,location:location },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantid: tenantIDUrl || tenantId,
          },
        }
      );

      if (res.data.status) {
        setLoginSpinner(false);
      } else {
        setLoginSpinner(false);
      }
    } catch (error) {
      // console.error("Error during authorization:", error);
      setLoginSpinner(false);
    }
  };

  const loginByDomain = async (voiceType) => {
    try {
      // Skip AACC login for Asterisk - use direct localStorage check
      if (isAsteriskVoiceType()) {
        // console.log("⏭️ Skipping AvcUrl API for Asterisk - loginByDomain");
        return;
      }

      const avayaDomain = JSON.parse(localStorage.getItem("avayaLogin")).voiceRecord;
      if (!avayaDomain?.avayaUserName) return;

      const res = await axios.post(
        `${AvcUrl}/voice/cct/login?username=${avayaDomain.avayaUserName}&password=${avayaDomain.avayaPassword}&domain=${avayaDomain.avayaDomain}`,
        {},
        { headers: {} }
      );

      if (res.data.status === "OK") {
        localStorage.setItem("ssoToken", res.data.data.ssoToken);
        localStorage.setItem("agentLoginTerminalId", res.data.data.agents[0].agentLoginId);
        localStorage.setItem("agentUsername", res.data.data.agents[0].agentUsername);
        localStorage.setItem("dashboard", true);

        if (res.data.data.agents[0].loggedIn === false) {
          await loginByDomainForAgent(voiceType);
        } else {
          const result = window.confirm("User Already Logged In...!");
          if (result) await logoutByDomainFirst();
        }
      } else {
        toast.error(
          res.data.message === "User Authentication Failed" ? "Wrong Password" : "Wrong Username",
          toastStyle
        );
      }
    } catch (err) {
      // console.error("Domain Login Error:", err);
    }
  };

  const loginByDomainForAgent = async () => {
    try {
      // Skip AACC agent login for Asterisk - use direct localStorage check
      if (isAsteriskVoiceType()) {
        // console.log("⏭️ Skipping AvcUrl API for Asterisk - loginByDomainForAgent");
        return;
      }

      const agentLoginTerminalId = localStorage.getItem("agentLoginTerminalId");
      const ssToken = localStorage.getItem("ssoToken");

      const res = await axios.post(
        `${AvcUrl}/voice/cct/agent/${agentLoginTerminalId}/login/${agentLoginTerminalId}?status=Ready`,
        {},
        { headers: { ssoToken: ssToken } }
      );

      if (res.data.status === "OK") {
        toast.success("Login Success", toastStyle);
        localStorage.setItem("VoiceStatusLastApiCallTime", Date.now());
        setTimeout(() => {
          setDashboard(true);
          setLoginPage(false);
        }, 1000);
      }
    } catch (error) {
      // console.error("Agent Login Error:", error);
    }
  };
  //  login functionalities //

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      loginByDcc();
    }
  };

  const togglePassword = () => {
    setIsShown((isShown) => !isShown);
    setEye(true);
  };

  const handleInputChange = (event) => {
    const newValue = event.target.value;
    if (/^\d*$/.test(newValue)) {
      setDailedNumber(newValue);
    }
  };

  // status update
  const changeStatusNew = (status, blockToast) => {
    // Skip AACC status update for Asterisk
    if (isAsteriskVoiceType()) {
      // console.log("⏭️ Skipping AvcUrl API for Asterisk - changeStatusNew");
      if (blockToast == true) {
        toast.success("Logout Successfully", toastStyle);
      } else {
        toast.success("Status Updated", toastStyle);
      }
      return;
    }

    const ssToken = localStorage.getItem("ssoToken");
    userStatusList();
    axios
      .post(
        AvcUrl +
        `/voice/cct/agent/${agentLoginTerminalId}/status?status=` + status,
        {},
        {
          headers: {
            ssoToken: ssToken,
          },
        }
      )
      .then((res) => {
        if (res.data.status === "OK") {
          if (res.data.message === "Success") {
            if (blockToast == true) {
              toast.success("Logout Successfully", toastStyle);
            } else {
              toast.success("Status Updated", toastStyle);
            }
            localStorage.setItem("VoiceStatusLastApiCallTime", Date.now());
          }
        }
      })
      .catch((error) => {
        // console.error(error);
      });
  };

  const updateStatusApi = async (statusName) => {
    const avayaLoginStr = localStorage.getItem("avayaLogin");
    let data = {};

    try {
      data = avayaLoginStr ? JSON.parse(avayaLoginStr) : {};
    } catch (error) {
      console.error("Error parsing avayaLogin:", error);
      data = {};
    }

    const userId = data?.user_id || "";

    // Log for debugging - can be removed later
    if (!userId) {
      console.warn("⚠️ updateStatusApi called with empty userId. avayaLogin:", avayaLoginStr);
    }

    // First API call to update status in our backend - always call this
    await axios
      .post(
        BaseURL + "/users/updateAgentStatus/",
        {
          status: statusName,
          userId: userId,
        },
        {
          headers: {
            Authorization:
              "Bearer " + localStorage.getItem("access_token_cognicx"),
            "Content-Type": "application/json",
            tenantId: tenantId,
          },
        }
      )
      .then(async (res) => {
        if (res.data.status) {
          // Skip AACC status update for Asterisk - use direct localStorage check
          // console.log("🔍 updateStatusApi - checking voiceType from localStorage");

          if (isAsteriskVoiceType()) {
            // console.log("⏭️ Skipping AvcUrl API for Asterisk - updateStatusApi");
            return;
          }

          // console.log("📞 Calling AACC status update API");
          await axios
            .post(
              AvcUrl +
              `/voice/cct/agent/${localStorage.getItem(
                "agentLoginTerminalId"
              )}/status?status=${statusName}`,
              {},
              {
                headers: {
                  ssoToken: localStorage.getItem("ssoToken")
                    ? localStorage.getItem("ssoToken")
                    : "",
                  tenantId: tenantId,
                },
              }
            )
            .then((res) => {
            })
            .catch((error) => {
              // console.log(error);
            });
        }
      })
      .catch((err) => {
        // console.log("updateStatus", err);
      });
  };

  // status list and set localstorage values //
  const getStatusDotClass = (status) => {
    if (status === "Ready") {
      return "status-dot-ready";
    } else if (status === "Connected") {
      return "status-dot-connected";
    } else {
      return "status-dot-not-ready";
    }
  };
  const updateStatus = (selectedValue) => {
    setSelectedStatus(selectedValue);
    localStorage.setItem("Status", selectedValue);
  };
  const userStatusList = async () => {
    let data = JSON.parse(localStorage.getItem("avayaLogin")) || {};
    if (!data || !data.user_id) {
      return;
    }
    await axios
      .post(
        BaseURL + "/userstatus/userstatuslist",
        {},
        {
          headers: {
            Authorization:
              "Bearer " + localStorage.getItem("access_token_cognicx"),
            "Content-Type": "application/json",
            tenantId: tenantId,
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setUserStatus(res.data.data);
        } else {
          setUserStatus([]);
        }
      })
      .catch((error) => {
        // console.log(error);
      });
  };
  // status list and set localstorage values //

  const displayScreen = (value) => {
    if (value == "dashboard") {
      $("#navbar").show();
      $("#dashboard").show();
      $("#outboundscreen").hide();
      $("#outboundAnsScreen").hide();
      $("#incomingScreen").hide();
      $("#incomingAnsScreen").hide();
      $("#transferScreen").hide();
      $("#conferanceScreen").hide();
      $("#InconferanceScreen").hide();
      $("#callLogsScreen").hide();
    } else if (value == "callLogsScreen") {
      $("#navbar").show();
      $("#callLogsScreen").show();
      $("#incomingScreen").hide();
      $("#dashboard").hide();
      $("#outboundscreen").hide();
      $("#outboundAnsScreen").hide();
      $("#incomingAnsScreen").hide();
      $("#transferScreen").hide();
      $("#conferanceScreen").hide();
      $("#InconferanceScreen").hide();
    } else if (value == "incomingScreen") {
      $("#navbar").hide();
      $("#incomingScreen").show();
      $("#dashboard").hide();
      $("#outboundscreen").hide();
      $("#outboundAnsScreen").hide();
      $("#incomingAnsScreen").hide();
      $("#transferScreen").hide();
      $("#conferanceScreen").hide();
      $("#InconferanceScreen").hide();
      $("#callLogsScreen").hide();
    } else if (value == "incomingAnsScreen") {
      $("#navbar").hide();
      $("#incomingAnsScreen").show();
      $("#dashboard").hide();
      $("#outboundscreen").hide();
      $("#outboundAnsScreen").hide();
      $("#incomingScreen").hide();
      $("#transferScreen").hide();
      $("#conferanceScreen").hide();
      $("#InconferanceScreen").hide();
      $("#callLogsScreen").hide();
    } else if (value == "outboundscreen") {
      $("#navbar").hide();
      $("#outboundscreen").show();
      $("#dashboard").hide();
      $("#incomingScreen").hide();
      $("#outboundAnsScreen").hide();
      $("#incomingAnsScreen").hide();
      $("#transferScreen").hide();
      $("#conferanceScreen").hide();
      $("#InconferanceScreen").hide();
      $("#callLogsScreen").hide();
    } else if (value == "outboundAnsScreen") {
      $("#navbar").hide();
      $("#outboundAnsScreen").show();
      $("#dashboard").hide();
      $("#outboundscreen").hide();
      $("#incomingScreen").hide();
      $("#incomingAnsScreen").hide();
      $("#transferScreen").hide();
      $("#conferanceScreen").hide();
      $("#InconferanceScreen").hide();
      $("#callLogsScreen").hide();
    } else if (value == "transferScreen") {
      $("#navbar").hide();
      $("#outboundAnsScreen").hide();
      $("#dashboard").hide();
      $("#outboundscreen").hide();
      $("#incomingScreen").hide();
      $("#incomingAnsScreen").hide();
      $("#transferScreen").show();
      $("#conferanceScreen").hide();
      $("#InconferanceScreen").hide();
      $("#callLogsScreen").hide();
    } else if (value == "conferanceScreen") {
      $("#navbar").hide();
      $("#outboundAnsScreen").hide();
      $("#dashboard").hide();
      $("#outboundscreen").hide();
      $("#incomingScreen").hide();
      $("#incomingAnsScreen").hide();
      $("#transferScreen").hide();
      $("#conferanceScreen").show();
      $("#InconferanceScreen").hide();
      $("#callLogsScreen").hide();
    } else if (value == "InconferanceScreen") {
      $("#navbar").hide();
      $("#outboundAnsScreen").hide();
      $("#dashboard").hide();
      $("#outboundscreen").hide();
      $("#incomingScreen").hide();
      $("#incomingAnsScreen").hide();
      $("#transferScreen").hide();
      $("#conferanceScreen").hide();
      $("#InconferanceScreen").show();
      $("#callLogsScreen").hide();
    }
    localStorage.setItem("currentPage", value);
    setRouteScreen(value);
  };
  const callActionModule = (value) => {
    if (value == "hold") {
      $(".hold").hide();
      $(".unhold").show();
    } else if (value == "mute") {
      $(".unmute").show();
      $(".mute").hide();
    } else if (value == "unmute") {
      $(".mute").show();
      $(".unmute").hide();
    } else if (value == "unhold") {
      $(".hold").show();
      $(".unhold").hide();
    } else if (value == "agenthold") {
      $(".agenthold").hide();
      $(".agentunhold").show();
    } else if (value == "agentunhold") {
      $(".agenthold").show();
      $(".agentunhold").hide();
    } else if (value == "transfer") {
      $("#transfer").show();
      $("#maketransfer").hide();
    } else if (value == "maketransfer") {
      $("#maketransfer").show();
      $("#transfer").hide();
    } else if (value == "conferance") {
      $("#conferance").show();
      $("#makeconferance").hide();
    } else if (value == "makeconferance") {
      $("#makeconferance").show();
      $("#conferance").hide();
    }
  };

  const makeCall = async (value1, value2) => {
    let agentLoginTerminalId = localStorage.getItem("agentLoginTerminalId");
    const prefixNumber = `${dailedNumber}`;
    if (prefixNumber.length > 12) {
      toast.error("Invalid number please check", toastStyle);
      return;
    }

    if (value1 == "normalcall") {
      if (agentLoginTerminalId === dailedNumber) {
        openModal();
        return;
      }
      if (dailedNumber === "") {
        openValidNumDiv();
        return;
      }
    }

    const numberToDial = value2 ? value2.calledno : dailedNumber;
    setDailedNumber(numberToDial);
    localStorage.setItem("ClickToCall", "true");

    // Check voiceType and route accordingly
    if (isAsteriskVoiceType()) {
      // ASTERISK CALL HANDLING
      // console.log("🔧 Making Asterisk SIP call to:", numberToDial);

      if (!BrowserPhoneSIP.isRegistered()) {
        toast.error("Inaipi phone not registered. Please check connection.", toastStyle);
        return;
      }

      try {
        // Show call screen immediately (using outboundAnsScreen since outboundscreen div doesn't exist)
        displayScreen("outboundAnsScreen");
        updateNumbersOnUI(numberToDial);

        const callResult = await BrowserPhoneSIP.call(numberToDial);
        const callId = callResult.id;

        localStorage.setItem("contactId", callId);
        localStorage.setItem("asteriskCallId", callId); // Store for recording URL generation
        localStorage.setItem("callType", "Outbound");
        localStorage.setItem("dailedNumber", numberToDial);
        // Set ringStartTime for rejected/busy calls (different from startTime used for duration)
        localStorage.setItem("ringStartTime", getFormattedGMTTime());
        console.log("📞 [ASTERISK] Stored Outbound CallID for recording:", callId);

        currentCall.current = callResult;

        // Don't start timer here - will start when call is answered
        // Timer will track duration from answered to ended, not ringing to ended

        // Call backend notification API with correct "from" number
        outboundRingNotify(getFromNumber(), numberToDial, callId);

        // console.log("✅ Asterisk call initiated successfully");

      } catch (error) {
        // console.error("❌ Failed to initiate call:", error);
        toast.error("Failed to initiate call", toastStyle);
      }

    } else {
      // AACC/STOMP CALL HANDLING (existing logic)
      let ssToken = localStorage.getItem("ssoToken");
      axios
        .post(
          AvcUrl +
          `/voice/terminal/${agentLoginTerminalId}/createContact/sip:${agentLoginTerminalId}@${VoiceDomainName}/sip:${value1 == "socketCall" ? value2.calledno : prefixNumber}@${VoiceDomainName}`,
          {},
          {
            headers: {
              ssoToken: ssToken,
            },
          }
        )
        .then((res) => {
          const contactId = res.data.data ? res.data.data.contactId : null;
          if (contactId) {
            localStorage.setItem("contactId", contactId);
            localStorage.setItem("callType", "Outbound");
            localStorage.setItem("dailedNumber", dailedNumber || value2.calledno);
            getTimer.reset();
            getTimer.startsTimer();
            outboundRingNotify(
              agentLoginTerminalId,
              dailedNumber || value2.calledno,
              contactId
            );
            // outboundAnsweredNotify will be called when STOMP "ACTIVE" event is received
          } else {
            // console.error("No contactId found in response:", res);
          }
        })
        .catch((err) => {
          // console.error(err);
        });
    }
  };

  const answerIncCall = async () => {
    let ssToken = localStorage.getItem("ssoToken");
    let contactId = localStorage.getItem("contactId");

    // Check voiceType and route accordingly
    if (isAsteriskVoiceType()) {
      // ASTERISK ANSWER HANDLING
      // console.log("🔧 Answering Asterisk call:", contactId);

      if (asteriskClient.current && currentCall.current) {
        try {
          await BrowserPhoneSIP.answer(contactId);
          // console.log("✅ Asterisk call answered successfully");

          // Enable audio playback after user interaction
          setTimeout(() => {
            BrowserPhoneSIP.enableAudioPlayback();
          }, 1000);

        } catch (error) {
          // console.error("❌ Failed to answer Asterisk call:", error);
          toast.error("Failed to answer call", toastStyle);
        }
      } else {
        // console.error("❌ No Asterisk client or current call available");
      }

    } else {
      // AACC ANSWER HANDLING (existing logic)
      if (avayaPlatform == "AACC") {
        axios
          .post(
            `${AvcUrl}/voice/terminal/${agentLoginTerminalId}/answer/${contactId}`,
            {},
            {
              headers: {
                ssoToken: ssToken,
              },
            }
          )
          .then((res) => {
            if ((res.data.status = "OK")) {
              getTimer.reset();
              getTimer.startsTimer();
              localStorage.setItem("callType", "Inbound");
              displayScreen("incomingAnsScreen");
            }
          })
          .catch((err) => {
            // console.error(err);
          });
      }
    }
  };

  const unhold_call = async (value) => {
    let contactId = localStorage.getItem("contactId");
    let ssToken = localStorage.getItem("ssoToken");
    // console.log("unhold_call");

    // Check voiceType and route accordingly
    if (isAsteriskVoiceType()) {
      // ASTERISK UNHOLD HANDLING
      // console.log("🔧 Unholding Asterisk call");

      if (asteriskClient.current) {
        try {
          await BrowserPhoneSIP.hold(false); // false means unhold
          // console.log("✅ Asterisk call unhold successfully");
        } catch (error) {
          // console.error("❌ Failed to unhold Asterisk call:", error);
          toast.error("Failed to unhold call", toastStyle);
        }
      }

    } else {
      // AACC UNHOLD HANDLING (existing logic)
      if (avayaPlatform == "AACC") {
        if (value == "customer") {
          axios
            .post(
              AvcUrl +
              `/voice/terminal/${agentLoginTerminalId}/unhold/` +
              contactId,
              {},
              {
                headers: {
                  ssoToken: ssToken,
                },
              }
            )
            .then(async (res) => {
              if ((res.data.status = "OK")) {
                // console.log("zoho_unhold...");
                callActionModule("unhold");
                $(".hold").show();
                $(".unhold").hide();
              }
            })
            .catch((err) => {
              // console.error(err);
            });
        } else if (value == "agent") {
          axios
            .post(
              AvcUrl +
              `/voice/terminal/${agentLoginTerminalId}/unhold/` +
              localStorage.getItem("agentContactIdtransfer"),
              {},
              {
                headers: {
                  ssoToken: ssToken,
                },
              }
            )
            .then(async (res) => {
              if ((res.data.status = "OK")) {
                // console.log("Agent call in unhold...");
                callActionModule("agentunhold");
              }
            })
            .catch((err) => {
              // console.error(err);
            });
        }
      }
    }
  };

  const hold_call = async (value) => {
    let contactId = localStorage.getItem("contactId");
    let ssToken = localStorage.getItem("ssoToken");
    // console.log("hold_call");

    // Check voiceType and route accordingly
    if (isAsteriskVoiceType()) {
      // ASTERISK HOLD HANDLING
      // console.log("🔧 Holding Asterisk call");

      if (asteriskClient.current) {
        try {
          await BrowserPhoneSIP.hold(true); // true means hold
          // console.log("✅ Asterisk call held successfully");
        } catch (error) {
          // console.error("❌ Failed to hold Asterisk call:", error);
          toast.error("Failed to hold call", toastStyle);
        }
      }

    } else {
      // AACC HOLD HANDLING (existing logic)
      if (avayaPlatform == "AACC") {
        if (value == "customer") {
          axios
            .post(
              AvcUrl +
              `/voice/terminal/${agentLoginTerminalId}/hold/` +
              contactId,
              {},
              {
                headers: {
                  ssoToken: ssToken,
                },
              }
            )
            .then(async (res) => {
              if ((res.data.status = "OK")) {
                // console.log("zoho_Hold...");
                callActionModule("hold");
                $(".hold").hide();
                $(".unhold").show();
              }
            })
            .catch((err) => {
              // console.error(err);
            });
        } else if (value == "agent") {
          axios
            .post(
              AvcUrl +
              `/voice/terminal/${agentLoginTerminalId}/hold/` +
              localStorage.getItem("agentContactIdtransfer"),
              {},
              {
                headers: {
                  ssoToken: ssToken,
                },
              }
            )
            .then(async (res) => {
              if ((res.data.status = "OK")) {
                // console.log("Agent call in unhold...");
                callActionModule("agenthold");
                callActionModule("unhold");
                unhold_call("customer");
                unhold_call("agent");
              }
            })
          .catch((err) => {
            // console.error(err);
          });
        }
      }
    }
  };

  const making_transfer_call = () => {
    // Skip AACC transfer for Asterisk (not yet supported)
    if (isAsteriskVoiceType()) {
      // console.log("⏭️ Skipping AvcUrl API for Asterisk - making_transfer_call (not supported)");
      toast.info("Transfer not yet supported", toastStyle);
      return;
    }

    let contactId = localStorage.getItem("contactId");
    let value = input;
    setAgenttransfernum(value);
    if (!value) {
      // console.error("Element with ID 'display1' not found.");
      return;
    }

    if (value === "") {
      closedialer();
      return;
    }
    if (value === localStorage.getItem("agentLoginTerminalId")) {
      closedialer();
      return;
    }
    closedialer();
    if (avayaPlatform == "AACC") {
      let ssToken = localStorage.getItem("ssoToken");
      axios
        .post(
          `${AvcUrl}/voice/terminal/${agentLoginTerminalId}/transfer/${value}/${contactId}`,
          {},
          {
            headers: {
              ssoToken: ssToken,
            },
          }
        )
        .then(async (res) => {
          if ((res.data.status = "OK")) {
            localStorage.setItem("agentcontactid", res.data.data.contactId);
            hold_call("customer");
            displayScreen("transferScreen");
            const storedCallingnum = localStorage.getItem("calledDeviceID");
            setStoredAgentNum(storedCallingnum);
          }
        })
        .catch((err) => {
          // console.error(err);
        });
    }
  };

  const makeTransferCall = () => {
    // Skip AACC complete transfer for Asterisk (not yet supported)
    if (isAsteriskVoiceType()) {
      // console.log("⏭️ Skipping AvcUrl API for Asterisk - makeTransferCall (not supported)");
      return;
    }

    let ssToken = localStorage.getItem("ssoToken");
    let contactId = localStorage.getItem("contactId");
    let avayaPlatform = "AACC";
    if (avayaPlatform == "AACC") {
      axios
        .post(
          `${AvcUrl}/voice/terminal/${agentLoginTerminalId}/transfer/complete/${localStorage.getItem(
            "agentcontactid"
          )}/${contactId}`,
          {},
          {
            headers: {
              ssoToken: ssToken,
            },
          }
        )
        .then((res) => {
          if ((res.data.status = "OK")) {
            // endChat();
          }
        })
        .catch((err) => {
          // console.error(err);
        });
    }
  };

  const make_Confrence_Call = () => {
    // Skip AACC conference for Asterisk (not yet supported)
    if (isAsteriskVoiceType()) {
      // console.log("⏭️ Skipping AvcUrl API for Asterisk - make_Confrence_Call (not supported)");
      toast.info("Conference not yet supported", toastStyle);
      return;
    }

    let contactId = localStorage.getItem("contactId");
    let value = input;
    setAgentconfnum(value);
    if (!value) {
      // console.error("Element with ID 'output' not found.");
      return;
    }

    if (value === "") {
      closedialer();
      return;
    }
    if (value === localStorage.getItem("agentLoginTerminalId")) {
      closedialer();
      return;
    }
    closedialer2();
    if (avayaPlatform == "AACC") {
      let ssToken = localStorage.getItem("ssoToken");
      axios
        .post(
          `${AvcUrl}/voice/terminal/${agentLoginTerminalId}/conference/${value}/${contactId}`,
          {},
          {
            headers: {
              ssoToken: ssToken,
            },
          }
        )
        .then(async (res) => {
          if ((res.data.status = "OK")) {
            localStorage.setItem("agentcontactid", res.data.data.contactId);
            hold_call("customer");
            displayScreen("conferanceScreen");
            const storecallednum = localStorage.getItem("calledDeviceID");
            setStoredConferAgentNum(storecallednum);
          }
        })
        .catch((err) => {
          // console.error(err);
        });
    }
  };

  const mergeCall = () => {
    // Skip AACC complete conference for Asterisk (not yet supported)
    if (isAsteriskVoiceType()) {
      // console.log("⏭️ Skipping AvcUrl API for Asterisk - mergeCall (not supported)");
      return;
    }

    if (avayaPlatform == "AACC") {
      let ssToken = localStorage.getItem("ssoToken");
      axios
        .post(
          `${AvcUrl}/voice/terminal/${agentLoginTerminalId}/conference/complete/${localStorage.getItem(
            "agentcontactid"
          )}/${localStorage.getItem("contactId")}`,
          {},
          {
            headers: {
              ssoToken: ssToken,
            },
          }
        )
        .then(async (res) => {
          if ((res.data.status = "OK")) {
            displayScreen("InconferanceScreen");
          }
        })
        .catch((err) => {
          // console.error(err);
        });
    }
  };

  const end_call = async (value) => {
    let contactId = localStorage.getItem("contactId");
    let agentLoginTerminalId = localStorage.getItem("agentLoginTerminalId");

    // Check voiceType and route accordingly
    if (isAsteriskVoiceType()) {
      // ASTERISK END CALL HANDLING
      // console.log("🔧 Ending Asterisk call");

      if (asteriskClient.current) {
        try {
          await BrowserPhoneSIP.hangup();
          // console.log("✅ Asterisk call ended successfully");

          // Note: Backend notification will be handled by BrowserPhoneSIP "callEnded" event
          // No need to call outboundEndedNotify/inboundEndedNotify here to avoid duplicates

        } catch (error) {
          console.error("❌ Failed to end Asterisk call:", error);
          toast.error("Failed to end call: " + (error.message || "Unknown error"), toastStyle);
        }
      } else {
        console.warn("⚠️ No Asterisk client available to end call");
      }

    } else {
      // AACC END CALL HANDLING (existing logic)
      if (avayaPlatform == "AACC") {
        if (value == "transfer") {
          let ssToken = localStorage.getItem("ssoToken");
          axios
            .post(
              AvcUrl +
              `/voice/terminal/${agentLoginTerminalId}/disconnect/` +
              localStorage.getItem("agentcontactid"),
              {},
              {
                headers: {
                  ssoToken: ssToken,
                },
              }
            )
            .then((res) => {
              if (res.data.status == "OK") {
                displayScreen("dashboard");
                setDailedNumber("");
              }
            })
            .catch((err) => {
              // console.error(err);
            });
        } else {
          let ssToken = localStorage.getItem("ssoToken");
          axios
            .post(
              AvcUrl +
              `/voice/terminal/${agentLoginTerminalId}/disconnect/` +
              contactId,
              {},
              {
                headers: {
                  ssoToken: ssToken,
                },
              }
            )
            .then((res) => {
              if ((res.data.status = "OK")) {
                displayScreen("dashboard");
                setDailedNumber("");
              }
            })
            .catch((err) => {
              // console.error(err);
            });
        }
      }
    }
  };

  const CreateAbandoned = (value) => {
    axios
      .post(
        BaseURL + "/users/callcreateSession",
        {
          name: "",
          email_id: "",
          phone:
            localStorage.getItem("callingDeviceID") || value.callingDeviceID,
          channel: "voice",
          latitude: "",
          longitute: "",
          skillset:
            localStorage.getItem("SkillSet") == "null"
              ? "NA"
              : localStorage.getItem("SkillSet") || value.skillSet,
          language: "English",
          complaint: "",
          agent_id: JSON.parse(localStorage.getItem("avayaLogin")).id,
          agent_extension: localStorage.getItem("AvayaUsername"),
          direction: value.callType,
          contactId: localStorage.getItem("contactId") || value.contactId,
          UUID_contactId: localStorage.getItem("contactId") || value.contactId,
          UUID_externalContactId: "",
          UUID_calledDeviceID:
            localStorage.getItem("calledDeviceID") || value.calledDeviceID,
          UUID_callingDeviceID:
            localStorage.getItem("callingDeviceID") || value.callingDeviceID,
          UUID_callingAgentName:
            localStorage.getItem("callingDeviceID") || value.callingDeviceID,
          UUID_skillSet:
            localStorage.getItem("SkillSet") == "null"
              ? "NA"
              : localStorage.getItem("SkillSet"),
          callArrivalTime: localStorage.getItem("callArrivalTime"),
        },
        {
          headers: {
            Authorization:
              "Bearer " + localStorage.getItem("access_token_cognicx"),
            "Content-Type": "application/json",
            tenantId: tenantId,
          },
        }
      )
      .then(async (res) => {
        if (res.data.status == true) {
          localStorage.setItem("zohoSession", res.data.chat_session_id);
        } else {
          toast.error("Something went Wrong", toastStyle);
          localStorage.removeItem("incomingNumber");
          localStorage.removeItem("callArrivalTime");
          localStorage.removeItem("SkillSet");
          localStorage.removeItem("contactId");
          localStorage.removeItem("mainContactId");
        }
      })
      .catch((err) => {
        // console.log("err", err);
      });
  };

  const CreateAbandonedRejectCall = () => {
    axios
      .post(
        BaseURL + "/users/callcreateSession",
        {
          name: "",
          email_id: "",
          phone: localStorage.getItem("callingDeviceID"),
          channel: "voice",
          latitude: "",
          longitute: "",
          skillset:
            localStorage.getItem("SkillSet") == "null"
              ? "NA"
              : localStorage.getItem("SkillSet"),
          language: "English",
          complaint: "",
          agent_id: JSON.parse(localStorage.getItem("avayaLogin")).id,
          agent_extension: localStorage.getItem("AvayaUsername"),
          direction: "Inbound",
          contactId: localStorage.getItem("contactId"),
          UUID_contactId: localStorage.getItem("contactId"),
          UUID_externalContactId: "",
          UUID_calledDeviceID: localStorage.getItem("calledDeviceID"),
          UUID_callingDeviceID: localStorage.getItem("callingDeviceID"),
          UUID_callingAgentName: localStorage.getItem("callingDeviceID"),
          UUID_skillSet:
            localStorage.getItem("SkillSet") == "null"
              ? "NA"
              : localStorage.getItem("SkillSet"),
          isabandoned: true,
          callArrivalTime: localStorage.getItem("callArrivalTime"),
        },
        {
          headers: {
            Authorization:
              "Bearer " + localStorage.getItem("access_token_cognicx"),
            "Content-Type": "application/json",
            tenantId: tenantId,
          },
        }
      )
      .then(async (res) => {
        if (res.data.status == true) {
          displayScreen("dashboard");
        } else {
        }
      })
      .catch((err) => {
        // console.log("err", err);
      });
  };

  const endChat = () => {
    // console.log("endChat_calling")
    axios
      .post(
        BaseURL + "/message/endchat",
        {
          chat_session_id: localStorage.getItem("zohoSession"),
          chatendby: "Agent",
          reason: "Released",
          comment: "Completed",
          agent_id: JSON.parse(localStorage.getItem("avayaLogin")).id,
        },
        {
          headers: {
            tenantId: tenantId,
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          // console.log("endChat_success")
          localStorage.removeItem("zohoSession");
        } else {
        }
      })
      .catch((error) => {
        // console.log(error);
      });
  };

  const inboundRingNotify = (resEvent) => {
    const loggedInAgent = JSON.parse(localStorage.getItem("avayaLogin")) || {};

    axios
      .post(
        callNotifyUrl + "/channel/incomingCallNotify",
        {
          channel: "zoho",
          type: "received",
          state: "ringing",
          emailId: loggedInAgent.email,
          userId: loggedInAgent.user_id,
          id: resEvent.contactId,
          from: `+${resEvent.callingDeviceID}`,
          to: resEvent.calledDeviceID || getFromNumber(),
        },
        {
          headers: {
            Authorization:
              "Bearer " + localStorage.getItem("access_token_cognicx"),
            "Content-Type": "application/json",
            tenantId: tenantId,
          },
        }
      )
      .then(() => { })
      .catch((error) => {
        // console.error("Error fetching Incoming Call Notify:", error);
      });
  };
  const outboundRingNotify = (from, to, id) => {
       const loggedInAgent = JSON.parse(localStorage.getItem("avayaLogin")) || {};
    axios
      .post(
        callNotifyUrl + "/channel/outgoingCallNotify",
        {
          channel: "zoho",
          type: "dialed",
          state: "ringing",
          emailId: loggedInAgent.email,
          userId: loggedInAgent.user_id,
          id: id,
          from: from,
          to: `+${to}`,
        },
        {
          headers: {
            Authorization:
              "Bearer " + localStorage.getItem("access_token_cognicx"),
            "Content-Type": "application/json",
            tenantId: tenantId,
          },
        }
      )
      .then(() => { })
      .catch((error) => {
        // console.error("Error fetching Outgoing Call Notify:", error);
      });
  };
  const inboundAnsweredNotify = (resEvent) => {
    const getnotifyval = JSON.parse(localStorage.getItem("inboundnotifyval"));
    const loggedInAgent = JSON.parse(localStorage.getItem("avayaLogin")) || {};

    axios
      .post(
        callNotifyUrl + "/channel/incomingCallNotify",
        {
          channel: "zoho",
          type: "received",
          state: "answered",
          emailId: loggedInAgent.email,
          userId: loggedInAgent.user_id,
          id: getnotifyval.contactId,
          from: `+${getnotifyval.callingDeviceID}`,
          to: getnotifyval.calledDeviceID || getFromNumber(),
        },
        {
          headers: {
            Authorization:
              "Bearer " + localStorage.getItem("access_token_cognicx"),
            "Content-Type": "application/json",
            tenantId: tenantId,
          },
        }
      )
      .then(() => { })
      .catch((error) => {
        // console.error("Error fetching Incoming Call Notify:", error);
      });
  };
  const outboundAnsweredNotify = async(resEvent) => {
    const startTime = localStorage.getItem("startTime");
    const dailedNumber = localStorage.getItem("dailedNumber");
    const toNumber = dailedNumber?.startsWith('+') ? dailedNumber : `+${dailedNumber}`;
    const loggedInAgent = JSON.parse(localStorage.getItem("avayaLogin")) || {};

   await axios
      .post(
        callNotifyUrl + "/channel/outgoingCallNotify",
        {
          channel: "zoho",
          type: "dialed",
          state: "answered",
          emailId: loggedInAgent.email,
          userId: loggedInAgent.user_id,
          id: localStorage.getItem("contactId"),
          from: getFromNumber(),
          to: toNumber,
          start_time: startTime, // Already in GMT format from getFormattedGMTTime()
        },
        {
          headers: {
            Authorization:
              "Bearer " + localStorage.getItem("access_token_cognicx"),
            "Content-Type": "application/json",
            tenantId: tenantId,
          },
        }
      )
      .then(() => { })
      .catch((error) => {
        // console.error("Error fetching Outgoing Call Notify:", error);
      });
  };
  const inboundEndedNotify = async(resEvent) => {
    const startTime = localStorage.getItem("startTime");
    const formattedDuration = localStorage.getItem("formattedTime") || "00:00";
    const getnotifyval = JSON.parse(localStorage.getItem("inboundnotifyval"));
    const loggedInAgent = JSON.parse(localStorage.getItem("avayaLogin")) || {};

    // Generate recording URL from stored CallID
    const fullCallId = localStorage.getItem("asteriskCallId");
    let recordingUrl = null;

    if (fullCallId && isAsteriskVoiceType()) {
      // Extract recording ID from full CallID
      // Outbound format (no hyphens): 3qgt570th3lq938idkc58h13pgcjjc
      // Inbound format (with hyphens): d0de8137-5099-4464-b3b9-8109f958bc75e21ee30e-dcf9-4090-9ade-e94c707d1f95

      let recordingId = '';
      if (fullCallId.includes('-')) {
        // Inbound: Take first 32 hex characters (excluding hyphens) but keep hyphens
        let charCount = 0;
        for (let i = 0; i < fullCallId.length && charCount < 32; i++) {
          recordingId += fullCallId[i];
          if (fullCallId[i] !== '-') {
            charCount++;
          }
        }
      } else {
        // Outbound: Take first 20 characters (no hyphens)
        // Input: 3qgt570th3lq938idkc58h13pgcjjc
        // Output: 3qgt570th3lq938idkc5
        recordingId = fullCallId.substring(0, 20);
      }

      //recordingUrl = `http://3.109.111.103/recording/${recordingId}.wav`;
      recordingUrl = `http://10.61.104.232/recording/${recordingId}.wav`;
      console.log("🎙️ [ASTERISK] Inbound call recording URL:", recordingUrl);
    }

    const payload = {
      channel: "zoho",
      type: "received",
      state: "ended",
      emailId: loggedInAgent.email,
      userId: loggedInAgent.user_id,
      id: getnotifyval?.contactId,
      from: `+${getnotifyval?.callingDeviceID}`,
      to: getnotifyval?.calledDeviceID || getFromNumber(),
      start_time: startTime, // Already in GMT format from getFormattedGMTTime()
      duration: formattedDuration,
    };

    // Add recording URL if available
    if (recordingUrl) {
      payload.recording_url = recordingUrl;
    }

   await axios
      .post(
        callNotifyUrl + "/channel/incomingCallNotify",
        payload,
        {
          headers: {
            Authorization:
              "Bearer " + localStorage.getItem("access_token_cognicx"),
            "Content-Type": "application/json",
            tenantId: tenantId,
          },
        }
      )
      .then(() => {
        // Update voice URI in Zoho if recording URL is available
        if (recordingUrl && getnotifyval?.contactId) {
          axios.post(
            callNotifyUrl + "/channel/updateVoiceURI",
            {
              channel: "zoho",
              userId: loggedInAgent.user_id,
              id: getnotifyval.contactId,
              voiceuri: recordingUrl
            },
            {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token_cognicx"),
                "Content-Type": "application/json",
                tenantId: tenantId,
              },
            }
          )
          .then((response) => {
            console.log("✅ [ASTERISK] Inbound recording URL updated in Zoho:", response.data);
          })
          .catch((error) => {
            console.error("❌ [ASTERISK] Failed to update recording URL in Zoho:", error);
          });
        }
      })
      .catch((error) => {
        // console.error("Error fetching Incoming Call Notify", error);
      });
  };
  const outboundEndedNotify = async(resEvent, customState) => {
    const startTime = localStorage.getItem("startTime");
    const ringStartTime = localStorage.getItem("ringStartTime");
    const formattedDuration = localStorage.getItem("formattedTime") || "00:00";
    const loggedInAgent = JSON.parse(localStorage.getItem("avayaLogin")) || {};
    const dailedNumber = localStorage.getItem("dailedNumber");
    const toNumber = dailedNumber?.startsWith('+') ? dailedNumber : `+${dailedNumber}`;

    // Determine state: use customState if provided, otherwise check if call was answered
    const callState = customState || (localStorage.getItem("outboundCallAnswered") === "true" ? "ended" : "busy");

    console.log("📞 [ASTERISK] outboundEndedNotify - State:", callState, "Answered:", localStorage.getItem("outboundCallAnswered"));

    // Use startTime if call was answered, otherwise use ringStartTime for rejected/busy calls
    const timeToSend = startTime || ringStartTime;

    // Generate recording URL from stored CallID (only for answered calls)
    let recordingUrl = null;
    const fullCallId = localStorage.getItem("asteriskCallId");

    if (fullCallId && isAsteriskVoiceType() && callState === "ended") {
      // Extract recording ID from full CallID
      // Outbound format (no hyphens): 3qgt570th3lq938idkc58h13pgcjjc
      // Inbound format (with hyphens): d0de8137-5099-4464-b3b9-8109f958bc75e21ee30e-dcf9-4090-9ade-e94c707d1f95

      let recordingId = '';
      if (fullCallId.includes('-')) {
        // Inbound: Take first 32 hex characters (excluding hyphens) but keep hyphens
        let charCount = 0;
        for (let i = 0; i < fullCallId.length && charCount < 32; i++) {
          recordingId += fullCallId[i];
          if (fullCallId[i] !== '-') {
            charCount++;
          }
        }
      } else {
        // Outbound: Take first 20 characters (no hyphens)
        // Input: 3qgt570th3lq938idkc58h13pgcjjc
        // Output: 3qgt570th3lq938idkc5
        recordingId = fullCallId.substring(0, 20);
      }

      //recordingUrl = `http://3.109.111.103/recording/${recordingId}.wav`;
      recordingUrl = `http://10.61.104.232/recording/${recordingId}.wav`;
      console.log("🎙️ [ASTERISK] Outbound call recording URL:", recordingUrl);
    }

    const payload = {
      channel: "zoho",
      type: "dialed",
      state: callState,
      emailId: loggedInAgent.email,
      userId: loggedInAgent.user_id,
      id: localStorage.getItem("contactId"),
      from: getFromNumber(),
      to: toNumber,
      start_time: timeToSend, // Use answered time if available, else ring start time
    };

    // Only include duration if call was answered (state is "ended")
    if (callState === "ended") {
      payload.duration = formattedDuration;
    }

    // Add recording URL if available
    if (recordingUrl) {
      payload.recording_url = recordingUrl;
    }

   await axios
      .post(
        callNotifyUrl + "/channel/outgoingCallNotify",
        payload,
        {
          headers: {
            Authorization:
              "Bearer " + localStorage.getItem("access_token_cognicx"),
            "Content-Type": "application/json",
            tenantId: tenantId,
          },
        }
      )
      .then(() => {
        // Update voice URI in Zoho if recording URL is available
        if (recordingUrl && payload.id) {
          axios.post(
            callNotifyUrl + "/channel/updateVoiceURI",
            {
              channel: "zoho",
              userId: loggedInAgent.user_id,
              id: payload.id,
              voiceuri: recordingUrl
            },
            {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token_cognicx"),
                "Content-Type": "application/json",
                tenantId: tenantId,
              },
            }
          )
          .then((response) => {
            console.log("✅ [ASTERISK] Outbound recording URL updated in Zoho:", response.data);
          })
          .catch((error) => {
            console.error("❌ [ASTERISK] Failed to update recording URL in Zoho:", error);
          });
        }
      })
      .catch((error) => {
        // console.error("Error fetching Outgoing Call Notify:", error);
      });
  };
  const abondedCallNotify = () => {
    const getnotifyval = JSON.parse(localStorage.getItem("inboundnotifyval"));
    const loggedInAgent = JSON.parse(localStorage.getItem("avayaLogin")) || {};

    // For missed calls, use ringStartTime since call was never answered
    const timeToSend = localStorage.getItem("startTime") || localStorage.getItem("ringStartTime");

    axios
      .post(
        callNotifyUrl + "/channel/incomingCallNotify",
        {
          channel: "zoho",
          emailId: loggedInAgent.email,
          userId: loggedInAgent.user_id,
          type: "received",
          state: "missed",
          id: localStorage.getItem("contactId"),
          from: getnotifyval.callingDeviceID,
          to: getnotifyval.calledDeviceID || getFromNumber(),
          start_time: timeToSend, // Use ringStartTime for missed calls
        },
        {
          headers: {
            Authorization:
              "Bearer " + localStorage.getItem("access_token_cognicx"),
            "Content-Type": "application/json",
            tenantId: tenantId,
          },
        }
      )
      .then(() => {
        displayScreen("dashboard");
        getTimer.pauseTimer();
        updateStatusApi("Not Ready");
      })
      .catch((error) => {
        // console.error("Error fetching List Contacts:", error);
      });
  };

  const missedCallNotify = async() => {
    const loggedInAgent = JSON.parse(localStorage.getItem("avayaLogin")) || {};

    // For busy/missed calls, use ringStartTime since call was never answered
    const timeToSend = localStorage.getItem("startTime") || localStorage.getItem("ringStartTime");

   await axios
      .post(
        callNotifyUrl + "/channel/outgoingCallNotify",
        {
          channel: "zoho",
          emailId: loggedInAgent.email,
          userId: loggedInAgent.user_id,
          type: "dialed",
          state: "busy",
          id: localStorage.getItem("contactId"),
          from: getFromNumber(),
          to: localStorage.getItem("dailedNumber"),
          start_time: timeToSend, // Use ringStartTime for busy calls
        },
        {
          headers: {
            Authorization:
              "Bearer " + localStorage.getItem("access_token_cognicx"),
            "Content-Type": "application/json",
            tenantId: tenantId,
          },
        }
      )
      .then(() => { })
      .catch((error) => {
        // console.error("Error fetching List Contacts:", error);
      });
  };
  const createCallNotify = () => {
    function formatDateToIST(inputDateStr) {
      const date = new Date(inputDateStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}+05:30`;
    }

    const startTime = localStorage.getItem("startTime");
    const inputDateStr = new Date(startTime);
    const formattedDate = formatDateToIST(inputDateStr);

    axios
      .post(
        callNotifyUrl + "/channel/createCall",
        {
          userId: loggedInAgent.user_id,
          role: loggedInAgent.role,
          channel: "zoho",
          subject:
            localStorage.getItem("callType") === "Inbound"
              ? localStorage.getItem("skillset")
              : "NA",
          Call_Type: localStorage.getItem("callType"),
          Call_Duration: localStorage.getItem("formattedTime"),
          Call_Start_Time: formattedDate,
          Phone:
            localStorage.getItem("callType") === "Inbound"
              ? localStorage.getItem("callingDeviceID")
              : localStorage.getItem("dailedNumber"),
        },
        {
          headers: {
            Authorization:
              "Bearer " + localStorage.getItem("access_token_cognicx"),
            "Content-Type": "application/json",
            tenantId: tenantId,
          },
        }
      )
      .then(() => { })
      .catch((error) => {
        // console.error("Error creating call:", error);
      });
  };

  let audio;
  const playAudio = () => {
    const audioUrl = "https://apps.inaipi.in/dailer/js/telephone_ring.mp3";

    if (!audio) {
      // Create the audio object only once
      audio = new Audio(audioUrl);
      audio.addEventListener("canplay", () => {
        // Play audio once it is ready
        audio.play().catch((error) => {
          // console.error("Failed to play audio:", error);
        });
      });
    } else {
      if (audio.paused) {
        // Play the audio if it's paused
        audio.play().catch((error) => {
          // console.error("Failed to play audio:", error);
        });
      }
    }
  };

  const pauseAudio = () => {
    if (audio && !audio.paused) {
      audio.pause();
    }
  };

  //// stomp server ////
  let stompClient;

  const initiateWebSocket = () => {
    // Skip AACC WebSocket for Asterisk
    if (isAsteriskVoiceType()) {
      // console.log("⏭️ Skipping AvcUrl WebSocket for Asterisk - initiateWebSocket");
      return;
    }

    const ssoToken = localStorage.getItem("ssoToken");
    if (!ssoToken) return // console.error("SSO Token is missing.");

    try {
      const socket = new SockJS(`${AvcUrl}/ws`);
      stompClient = Stomp.over(socket);
      // console.log("WebSocket client initialized");

      stompClient.connect(
        { terminal: ssoToken },
        () => {
          // console.log("WebSocket connected.");
          onConnected();
        },
        (error) => {
          // console.error("WebSocket connection error:", error);
          onError(error);
        }
      );
    } catch (error) {
      // console.error("Error initializing WebSocket:", error);
    }
  };

  const updateNumbersOnUI = (number) => {
    ["incommingNumber", "incommingNumber2", "outgoingNumber"].forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.innerHTML = number;
    });
  };

  // const getFormattedDateTime = () => {
  //   const dt = new Date();
  //   return `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")} ${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}:${String(dt.getSeconds()).padStart(2, "0")}`;
  // };
  const convertUTCToLocal = (utcStr) => {
    const utcDate = new Date(utcStr + " UTC");

    let hours = utcDate.getHours();
    const minutes = String(utcDate.getMinutes()).padStart(2, "0");
    const seconds = String(utcDate.getSeconds()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12;
    hours = hours ? hours : 12;

    return `${utcDate.getFullYear()}-${String(utcDate.getMonth() + 1).padStart(2, "0")}-${String(utcDate.getDate()).padStart(2, "0")} ${String(hours).padStart(2, "0")}:${minutes}:${seconds} ${ampm}`;
  };

  const getFormattedGMTTime = () => {
    const dt = new Date();

    let hours = dt.getUTCHours();
    const minutes = String(dt.getUTCMinutes()).padStart(2, "0");
    const seconds = String(dt.getUTCSeconds()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12;
    hours = hours ? hours : 12;

    return `${dt.getUTCFullYear()}-${String(dt.getUTCMonth() + 1).padStart(2, "0")}-${String(dt.getUTCDate()).padStart(2, "0")} ${String(hours).padStart(2, "0")}:${minutes}:${seconds} ${ampm}`;
  };

  const onConnected = () => {
    setTimeout(() => {
      // console.log("Stomp onConnected");
      stompClient.subscribe("/user/terminal/messages", (payload) => {
        const data = JSON.parse(payload.body);
        const { event, callType, contactId, callingDeviceID, skillSet, reason } = data;

        switch (event) {
          case "RINGING":
            // Set ringStartTime for missed/rejected calls (different from startTime used for duration)
            localStorage.setItem("ringStartTime", getFormattedGMTTime());
            localStorage.setItem("contactId", contactId);
            updateNumbersOnUI(callingDeviceID);
            displayScreen("incomingScreen");
            playAudio();

            if (callType === "Inbound") {
              localStorage.setItem("ClickToCall", "false");
              inboundRingNotify(data);
              localStorage.setItem("inboundnotifyval", JSON.stringify(data));
              localStorage.setItem("skillset", skillSet);
            } else if (callType === "Outbound") {
              localStorage.getItem("ClickToCall") === "true" ? outboundRingNotify(data) : inboundRingNotify(data);
            } else {
              localStorage.setItem("agenttransConf", true);
              localStorage.setItem("mainContactId", data.mainContactId);
            }
            break;

          case "ACTIVE":
            // Set start time when call becomes ACTIVE (answered) for duration tracking
            localStorage.setItem("startTime", getFormattedGMTTime());
            localStorage.setItem("calledDeviceID", data.calledDeviceID);
            localStorage.setItem("callingDeviceID", callingDeviceID);
            pauseAudio();

            if (callType === "Inbound" && contactId === localStorage.getItem("contactId")) {
              if (!localStorage.getItem("zohoSession")) {
                CreateAbandoned({
                  ...data,
                  callType: localStorage.getItem("ClickToCall") === "true" ? "Outbound" : "Inbound",
                });
              }
            } else if (callType === "Outbound") {
              displayScreen("outboundAnsScreen");
              // Notify backend that outbound call is answered
              console.log("outboundAnsweredNotify1")
              outboundAnsweredNotify();
              if (!localStorage.getItem("zohoSession")) {
                CreateAbandoned({
                  ...data,
                  callType: localStorage.getItem("ClickToCall") === "true" ? "Outbound" : "Inbound",
                });
              }
            }
            break;

          case "HELD":
            // console.log("HELD EVENT", data);
            break;

          case "DROPPED":
            // console.log("DROPPED", data);
            handleDroppedScenarios(data);
            break;

          default:
            break;
        }
      });
    }, 500);
  };

  const handleDroppedScenarios = (data) => {
    const { reason, contactId } = data;
    const currentId = localStorage.getItem("contactId");

    if (reason === "DEFAULT") {
      if (contactId === currentId) {
        getTimer.pauseTimer();
        handleDroppedEvent();
        displayScreen("dashboard");
        localStorage.removeItem("agenttransConf");
        localStorage.removeItem("callnumber");
      } else if (contactId === localStorage.getItem("agentcontactid")) {
        localStorage.removeItem("agentcontactid");
        displayScreen("incomingAnsScreen");
      }

      const isInbound = localStorage.getItem("isInboundCallActive") === "true";
      const isClickToCall = localStorage.getItem("ClickToCall") === "true";
      const endedInbound = localStorage.getItem("agentEndedInboundCall") === "true";
      const endedOutbound = localStorage.getItem("agentEndedOutboundCall") === "true";

      if (!endedInbound && !endedOutbound) {
        if (isClickToCall) {
          console.log("first",data)
          outboundEndedNotify(data);
          endChat();
        } else {
          isInbound ? inboundEndedNotify(data) : abondedCallNotify(data);
          endChat();
        }
      }

      setTimeout(() => {
        setDailedNumber("");
        [
          "ClickToCall", "isInboundCallActive", "agentEndedInboundCall", "agentEndedOutboundCall",
          "zohoSession", "calledDeviceID", "callingDeviceID", "contactId",
          "dailedNumber", "callType", "skillset", "inboundnotifyval",
          "startTime", "formattedTime", "asteriskCallId"
        ].forEach(localStorage.removeItem.bind(localStorage));
      }, 500);

    } else if (["TRANSFER_COMPLETE", "CONFERENCE_COMPLETE"].includes(reason)) {
      const isOutbound = localStorage.getItem("callType") === "Outbound";
      const isConf = localStorage.getItem("agenttransConf");

      if (isConf) {
        localStorage.removeItem("contactId");
        localStorage.setItem("contactId", localStorage.getItem("mainContactId"));
        localStorage.removeItem("agenttransConf");
        localStorage.removeItem("mainContactId");
        displayScreen("incomingAnsScreen");
      } else {
        localStorage.removeItem("contactId");
        isOutbound
          ? localStorage.removeItem("agentcontactid")
          : localStorage.removeItem("agentcontactid");
        displayScreen(reason === "TRANSFER_COMPLETE" ? "dashboard" : "InconferanceScreen");
        handleDroppedEvent();
      }
    }
  };

  const onError = (error) => {
    // console.error("Stomp Error", error);
  };

  const onDisconnectWebSocket = () => {
    if (stompClient) stompClient.disconnect();
  };


  //// update arrival time function////
  const getArrivalTime = (arrivetimer) => {
    if (!(arrivetimer instanceof Date)) {
      return "Invalid Date";
    }
    const hours = arrivetimer.getHours();
    const minutes = arrivetimer.getMinutes();
    const period = hours >= 12 ? "pm" : "am";
    const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
    return `${formattedHours}:${minutes < 10 ? "0" : ""}${minutes}${period}`;
  };

  ////after drop the call callback function ////
  const handleDroppedEvent = () => {
    const now = new Date();
    const callNumber = localStorage.getItem("callType") === "Inbound"
      ? localStorage.getItem("callingDeviceID")
      : localStorage.getItem("dailedNumber");
    const arrivalTime = getArrivalTime(now);
    const storedFormatvalue = localStorage.getItem("formattedTime");

    addCallLog(
      localStorage.getItem("callType"),
      callNumber,
      arrivalTime,
      storedFormatvalue
    );
  };

  const addCallLog = (
    callType,
    callNumber,
    arrivalTime,
    storedFormatvalued
  ) => {
    const newCallLogEntry = `
        <div class="d-flex align-items-center border-bottom py-3">
          <img src=${person} class="call-log-images" style="width: 40px; height: 40px"/>
          <div class="w-100 ms-3">
            <div class="d-flex w-100 justify-content-between">
               <h6 class="mb-0">${callNumber}</h6>
              <small>${arrivalTime}</small>
            </div>
            <div>
              ${callType === "Inbound"
        ? `<span style="font-size: medium; color: green" class="material-symbols-outlined call_icons_received">
                      call_received
                    </span>`
        : `<span style="font-size: medium; color: red" class="material-symbols-outlined call_icons_made">
                      call_made
                    </span>`
      }
              <small>duration: </small><small>${storedFormatvalued}</small>
            </div>
          </div>
        </div>`;
    const storedCallLogEntries = localStorage.getItem("callLogEntries");
    const existingEntries = storedCallLogEntries
      ? JSON.parse(storedCallLogEntries)
      : [];
    const entryExists = existingEntries.some(
      (entry) => entry === newCallLogEntry
    );
    if (!entryExists) {
      const updatedEntries = [newCallLogEntry, ...existingEntries];
      localStorage.setItem("callLogEntries", JSON.stringify(updatedEntries));
      setCallLogEntries(updatedEntries);
      $("#calllogs").scrollTop(0);
    }
  };

  const URLopen = () => {
    const url = `https://apps.inaipi.in/avayacms_ocbc/public/index.php/inaipi/livecall?mobilenumber=${localStorage.getItem(
      "callnumber"
    )}&uniqueid=1234567890&survey_opt=1&type=Web&agentname=admin`;
    window.open(url);
    answerIncCall();
    console.log("inboundAnsweredNotify1")
    inboundAnsweredNotify();
    localStorage.setItem("isInboundCallActive", true);
  };

  //WEBRTC//
  var callObj1 = null;
  var callObj2 = null;
  var callmap = {};
  var cli;
  var callIdnew;

  cli = new AWL.client();
  cli.enableLogging();

  const configuration = () => {
    const appInstanceId = cli.generateAppInstanceID();
    const cfg = {
      serviceType: "phone",
      enableVideo: true,
      Gateway: { ip: "ucd.inaipi.me", port: "5060" },
      Stunserver: { ip: "", port: "3478" },
      Turnserver: { ip: "", port: "3478", user: "2627", pwd: "222444666" },
      AppData: {
        applicationID: "xxxx12345",
        applicationUA: "sdktestclient-3.0.0",
        appInstanceID: appInstanceId,
      },
      disableResiliency: false,
    };

    const tags = {
      localVideo: "lclVideo",
      remoteVideo: "rmtVideo",
    };

    const onCallListener = new CallListener();
    const onAuthTokenRenewed = (resp) => {
      if (resp.result === "AWL_MSG_TOKEN_RENEW_SUCCESS") {
        // console.log("Token successfully renewed");
      } else {
        // console.error("Token renewal failed. Reason:", resp.reason);
      }
    };

    const onConfigChanged = (resp) => {
      // console.log(
      //   "Configuration Changed:",
      //   resp.result,
      //   "Reason:",
      //   resp.reason
      // );
    };

    const onRegistrationStateChanged = (resp) => {
      // console.log(
      //   "Registration State Changed:",
      //   resp.result,
      //   "Reason:",
      //   resp.reason
      // );

      if (resp.result === "AWL_MSG_LOGIN_SUCCESS") {
        const alternateServer = cli.getAlternateServerConfig();
        if (alternateServer) {
          // console.log(
          //   `Alternate Server: IP=${alternateServer.address}, Domain=${alternateServer.domain}, Port=${alternateServer.port}, Type=${alternateServer.serverType}`
          // );
        } else {
          // console.warn("Resiliency is not supported or enabled at the server.");
        }
      } else if (
        [
          "AWL_MSG_LOGIN_WEBSOCKET_FAILURE",
          "AWL_MSG_LINK_ISSUE_DETECTED",
        ].includes(resp.result)
      ) {
        // console.error("WebSocket login failure detected.");
      } else if (resp.result === "AWL_MSG_LOGIN_FAILED") {
        openLoginFailDiv();
      }
    };

    const configResult = cli.setConfiguration(
      cfg,
      onConfigChanged,
      onRegistrationStateChanged,
      onCallListener,
      onAuthTokenRenewed
    );

    var stunServer = { ip: "10.13.228.4", port: "5060" };
    var stunresult = cli.setStunConfiguration(stunServer);

    if (stunresult === "AWL_MSG_SET_STUN_CONFIG_SUCCESS") {
      // console.log("Successfully configured STUN settings");
    } else {
      // console.error("Could not configure STUN settings. Re-check the values");
    }

    const domResult = cli.setDomElements(tags);
    if (domResult === "AWL_MSG_SETDOM_FAILED") {
      // console.error("Failed to set DOM elements:", domResult);
    } else {
      // console.log("DOM elements set successfully.");
    }

    // Agent login
    const agentLoginTerminalId = localStorage.getItem("agentLoginTerminalId");
    if (agentLoginTerminalId && agentLoginTerminalId.trim() !== "") {
      cli.logIn(agentLoginTerminalId, "222444666", "false");
    } else {
      // console.error(
      //   "Agent login terminal ID is null or invalid. Please set a valid terminal ID before logging in."
      // );
    }
  };

  var CallListener = function () {
    var _onNewIncomingCall = function (callId, callObj, autoAnswer) {
      // console.log("onCallListener : onNewIncomingCall", callObj);
      // // console.log("onNewIncomingCall : getFarEndNumber = " + callObj.getFarEndNumber());
      // // console.log( "onNewIncomingCall : getFarEndName = " + callObj.getFarEndName());
      // // console.log("onNewIncomingCall : getSipUri = " + callObj.getSipUri());
      // // console.log("onNewIncomingCall : autoAnswer = " + autoAnswer);
      // // console.log("CallerId==============", callObj.getCallId());
      localStorage.setItem("CallerId", callObj.getCallId());
      // setCallerId(callObj.getCallId());

      if (typeof callmap[callId] === "undefined") {
        // // console.log("onCallStateChanged : New incoming CALL OBJECT ADDED");
        if (callObj1 === null) {
          // // console.log("onCallStateChanged : CallObj assigned to callObj1");
          callObj1 = callObj;
          callmap[callObj1.getCallId()] = callObj1;
        } else {
          // // console.log("onCallStateChanged : ALL LINES BUSY!!");
        }
      }
    };
    var _onCallStateChange = function (callId, callObj, event) {
      // console.log("SDK TEST: onCallStateChanged:", callObj);
      if (callObj1 == null) {
        callObj1 = callObj;
      } else {
        callObj2 = callObj;
      }
      if (callObj1 != null && callObj.getCallId() === callObj1.getCallId()) {
        // console.log("callObj1: callstate: " + callObj1.getCallState());
        switch (callObj1.getCallState()) {
          case "AWL_MSG_CALL_IDLE":
            // console.log("Event ==> call Idle");
            break;
          case "AWL_MSG_CALL_CONNECTED":
            // console.log("Event ==> CALL_CONNECTED");
            break;
          case "AWL_MSG_CALL_RINGING":
            // console.log("Event ==> CALL_RINGING");
            break;
          case "AWL_MSG_CALL_DISCONNECTED":
            // console.log("Event ==> CALL_DISCONNECTED");
            break;
          case "AWL_MSG_CALL_FAILED":
            // console.log("Event ==> CALL_FAILED");
            break;
          case "AWL_MSG_CALL_INCOMING":
            // console.log("Event ==> CALL_INCOMING");
            break;
          case "AWL_MSG_CALL_HELD":
            // console.log("Event ==> CALL_HELD");
            break;
          case "AWL_MSG_CALL_FAREND_UPDATE":
            // console.log("Event ==> CALL_FAREND_UPDATE");
            break;
          default:
            // console.log("Event ==> CallState doesn't match");
        }
      }
      if (callObj2 != null && callObj.getCallId() === callObj2.getCallId()) {
        // console.log("callObj1: callstate: " + callObj2.getCallState());
        switch (callObj2.getCallState()) {
          case "AWL_MSG_CALL_IDLE":
            // console.log("Event ==> call Idle");
            break;
          case "AWL_MSG_CALL_CONNECTED":
            // console.log("Event ==> CALL_CONNECTED");
            break;
          case "AWL_MSG_CALL_RINGING":
            // console.log("Event ==> CALL_RINGING");
            break;
          case "AWL_MSG_CALL_DISCONNECTED":
            // console.log("Event ==> CALL_DISCONNECTED");
            break;
          case "AWL_MSG_CALL_FAILED":
            // console.log("Event ==> CALL_FAILED");
            break;
          case "AWL_MSG_CALL_INCOMING":
            // console.log("Event ==> CALL_INCOMING");
            break;
          case "AWL_MSG_CALL_HELD":
            // console.log("Event ==> CALL_HELD");
            break;
          case "AWL_MSG_CALL_FAREND_UPDATE":
            // console.log("Event ==> CALL_FAREND_UPDATE");
            break;
          default:
            // console.log("Event ==> CallState doesn't match");
        }
      }
    };
    var _onCallTerminate = function (callId, reason) {
      if (callObj1 != null && callObj1.getCallId() === callId) {
        // console.log("call disconnecting reseting callobj to null");
        delete callmap[callObj1.getCallId()];
        // console.log("before reset", callObj1);
        callObj1 = null;
        // console.log("after reset", callObj1);
      } else {
        // console.log("Call Id doesn't match ");
      }
      // console.log(" callTerminate Reason: " + reason);
    };
    return {
      onNewIncomingCall: _onNewIncomingCall,
      onCallStateChange: _onCallStateChange,
      onCallTerminate: _onCallTerminate,
    };
  };
  //WEBRTC//----------------

  async function mute_call() {
    // Check voiceType and route accordingly
    if (isAsteriskVoiceType()) {
      // ASTERISK MUTE HANDLING
      // console.log("🔧 Muting Asterisk call");

      if (asteriskClient.current) {
        try {
          await BrowserPhoneSIP.mute(true);
          // console.log("✅ Asterisk call muted successfully");
        } catch (error) {
          // console.error("❌ Failed to mute Asterisk call:", error);
          toast.error("Failed to mute call", toastStyle);
        }
      }

    } else {
      // WEBRTC MUTE HANDLING (existing logic)
      if (cli.doMute(localStorage.getItem("CallerId"))) {
        // console.log("Mute SUCCESS");
        callActionModule("mute");
        $(".unmute").show();
        $(".mute").hide();
      }
    }
  }

  async function unmute_call() {
    // Check voiceType and route accordingly
    if (isAsteriskVoiceType()) {
      // ASTERISK UNMUTE HANDLING
      // console.log("🔧 Unmuting Asterisk call");

      if (asteriskClient.current) {
        try {
          await BrowserPhoneSIP.mute(false); // false means unmute
          // console.log("✅ Asterisk call unmuted successfully");
        } catch (error) {
          // console.error("❌ Failed to unmute Asterisk call:", error);
          toast.error("Failed to unmute call", toastStyle);
        }
      }

    } else {
      // WEBRTC UNMUTE HANDLING (existing logic)
      if (cli.doUnMute(localStorage.getItem("CallerId"))) {
        // console.log("Unmute SUCCESS");
        callActionModule("unmute");
        $(".mute").show();
        $(".unmute").hide();
      }
    }
  }
  function showdialer() {
    $("#dialer").show();
  }
  function closedialer() {
    $("#dialer").hide();
  }
  function showdialer2() {
    $("#dialer2").show();
  }
  function closedialer2() {
    $("#dialer2").hide();
  }

  //  ASTERISK SIP INTEGRATION  //
  const initializeAsteriskClient = async () => {
    // console.log("🔧 Initializing Asterisk SIP.js client");

    try {
      // Disconnect any existing connection first (important for page refresh)
      if (asteriskClient.current || BrowserPhoneSIP.isRegistered()) {
        // console.log("🔌 Disconnecting existing Asterisk connection before reconnecting");
        try {
          await BrowserPhoneSIP.disconnect();
          // Wait a bit for cleanup to complete
          await new Promise(resolve => setTimeout(resolve, 500));
        } catch (error) {
          // console.warn("⚠️ Error disconnecting existing Asterisk connection:", error);
        }
        asteriskClient.current = null;
        currentCall.current = null;
      }

      const avayaLogin = JSON.parse(localStorage.getItem("avayaLogin") || "{}");
      const voiceRecord = avayaLogin?.voiceRecord;

      // Check for extensionNo/extensionPass first, fallback to avayaUserName/avayaPassword
      const username = voiceRecord.extensionNo || voiceRecord.avayaUserName;
      const password = voiceRecord.extensionPass || voiceRecord.avayaPassword;
      const domain = voiceRecord.asteriskServer || voiceRecord.avayaDomain || "cognicx.callanywhere.co.in:8089";

      if (!username || !password) {
        // console.error("❌ Missing credentials in voiceRecord");
        toast.error("Missing credentials", toastStyle);
        return;
      }

      const config = {
        domain: domain,
        username: username,
        password: password
      };

      // console.log("🔧 Connecting to Asterisk with config:", {
      //   domain: config.domain,
      //   username: config.username
      // });

      // Check if SIP.js library is loaded
      if (!window.SIP) {
        // console.error("❌ SIP.js library not loaded! Make sure sip.js is included in index.html");
        toast.error("SIP.js library not loaded", toastStyle);
        return;
      }
      // console.log("✅ SIP.js library detected:", window.SIP);

      asteriskClient.current = BrowserPhoneSIP;

      // Setup event handlers for Asterisk
      setupAsteriskEventHandlers();

      // Connect using Browser-Phone implementation
      // console.log("📞 Calling BrowserPhoneSIP.connect()...");
      BrowserPhoneSIP.connect(config);
      // console.log("📞 BrowserPhoneSIP.connect() called, waiting for registration...");

    } catch (error) {
      // console.error("❌ Error initializing Asterisk SIP client:", error);
      toast.error("Failed to initialize phone client", toastStyle);
    }
  };

  const setupAsteriskEventHandlers = () => {
    // console.log("🔧 Setting up Asterisk event handlers");

    // Registration success
    BrowserPhoneSIP.on("registered", () => {
      // console.log("✅ Asterisk SIP registered successfully");
      toast.success("Inaipi Connected Successfully", toastStyle);
    });

    // Registration failed
    BrowserPhoneSIP.on("registrationFailed", (error) => {
      // console.error("❌ Asterisk SIP registration failed:", error);
      // console.error("Error details:", {
      //   message: error?.message,
      //   cause: error?.cause,
      //   response: error?.response
      // });
      toast.error(`Failed to register: ${error?.message || 'Unknown error'}`, toastStyle);
    });

    // Error handler
    BrowserPhoneSIP.on("error", (error) => {
      // console.error("❌ Asterisk SIP error:", error);
      toast.error(`SIP Error: ${error?.message || 'Unknown error'}`, toastStyle);
    });

    // Incoming call
    BrowserPhoneSIP.on("invite", (data) => {
      if (!isAsteriskVoiceType()) {
        // console.warn("⚠️ Ignoring SIP invite - not in Asterisk mode");
        return;
      }

      // console.log("📞 Incoming Asterisk call:", data);
      const callId = data.callId;
      currentCall.current = data;

      // Get caller information from SIP session
      const session = data.session;
      const remoteIdentity = session?.remoteIdentity?.uri;
      const callerNumber = remoteIdentity?.user || "Unknown";

      // Store call information
      localStorage.setItem("contactId", callId);
      localStorage.setItem("callType", "Inbound");
      localStorage.setItem("callingDeviceID", callerNumber);
      localStorage.setItem("calledDeviceID", agentLoginTerminalId || "Unknown");
      // Set ringStartTime for missed calls (different from startTime used for duration)
      localStorage.setItem("ringStartTime", getFormattedGMTTime());

      // Store inbound notification data for later use
      const inboundData = {
        contactId: callId,
        callingDeviceID: callerNumber,
        calledDeviceID: agentLoginTerminalId
      };
      localStorage.setItem("inboundnotifyval", JSON.stringify(inboundData));

      // Call backend API to notify incoming call
      inboundRingNotify(inboundData);

      // Update UI and play ring tone
      updateNumbersOnUI(callerNumber);
      displayScreen("incomingScreen");
      playAudio();
    });

    // Call connecting/ringing (outbound)
    BrowserPhoneSIP.on("callConnecting", (data) => {
      if (!isAsteriskVoiceType()) return;
      // console.log("📞 Asterisk call connecting/ringing");
      // Screen is already shown in makeCall, no need to change it here
    });

    // Call accepted/connected
    BrowserPhoneSIP.on("callAccepted", (data) => {
      console.log("callAccepted11",data)
      if (!isAsteriskVoiceType()) {
        // console.warn("⚠️ Ignoring SIP callAccepted - not in Asterisk mode");
        return;
      }

      // console.log("✅ Asterisk call accepted");
      pauseAudio();

      // Store the full CallID for recording URL generation later
      if (data.callId) {
        localStorage.setItem("asteriskCallId", data.callId);
        console.log("📞 [ASTERISK] Stored CallID for recording:", data.callId);
      }

      const callType = localStorage.getItem("callType");

      if (callType === "Inbound") {
        // Incoming call answered - Start timer and set start time NOW
        localStorage.setItem("startTime", getFormattedGMTTime());
        displayScreen("incomingAnsScreen");
        getTimer.reset();
        getTimer.startsTimer();
        console.log("inboundAnsweredNotify2")
        inboundAnsweredNotify();
        localStorage.setItem("isInboundCallActive", true);
        // Track that inbound call was answered
        localStorage.setItem("inboundCallAnswered", "true");

        // Create session for tracking
        if (!localStorage.getItem("zohoSession")) {
          CreateAbandoned({
            contactId: localStorage.getItem("contactId"),
            callType: "Inbound",
            callingDeviceID: localStorage.getItem("callingDeviceID"),
            calledDeviceID: agentLoginTerminalId,
            skillSet: localStorage.getItem("skillset") || "NA"
          });
        }
      } else if (callType === "Outbound") {
        // Outbound call answered - Start timer and set start time NOW
        localStorage.setItem("startTime", getFormattedGMTTime());
        getTimer.reset();
        getTimer.startsTimer();

        displayScreen("outboundAnsScreen");
        console.log("outboundAnsweredNotify2")
        outboundAnsweredNotify();
        // Track that outbound call was answered
        localStorage.setItem("outboundCallAnswered", "true");
      }

      // Enable audio playback
      setTimeout(() => {
        BrowserPhoneSIP.enableAudioPlayback();
      }, 1000);
    });

    // Call held
    BrowserPhoneSIP.on("callHeld", () => {
      if (!isAsteriskVoiceType()) return;
      // console.log("⏸️ Asterisk call held");
      callActionModule("hold");
      $(".hold").hide();
      $(".unhold").show();
    });

    // Call resumed
    BrowserPhoneSIP.on("callResumed", () => {
      if (!isAsteriskVoiceType()) return;
      // console.log("▶️ Asterisk call resumed");
      callActionModule("unhold");
      $(".hold").show();
      $(".unhold").hide();
    });

    // Call muted
    BrowserPhoneSIP.on("callMuted", () => {
      if (!isAsteriskVoiceType()) return;
      // console.log("🔇 Asterisk call muted");
      callActionModule("mute");
      $(".unmute").show();
      $(".mute").hide();
    });

    // Call unmuted
    BrowserPhoneSIP.on("callUnmuted", () => {
      if (!isAsteriskVoiceType()) return;
      // console.log("🔊 Asterisk call unmuted");
      callActionModule("unmute");
      $(".mute").show();
      $(".unmute").hide();
    });

    // Call ended
    BrowserPhoneSIP.on("callEnded", (eventData) => {
      if (!isAsteriskVoiceType()) {
        // console.warn("⚠️ Ignoring SIP callEnded - not in Asterisk mode");
        return;
      }

      // console.log("📞 Asterisk call ended:", eventData);
      pauseAudio();
      getTimer.pauseTimer();

      const callType = localStorage.getItem("callType");
      const isClickToCall = localStorage.getItem("ClickToCall") === "true";
      const isInbound = localStorage.getItem("isInboundCallActive") === "true";
      const inboundAnswered = localStorage.getItem("inboundCallAnswered") === "true";

      // Call backend notification APIs
      if (callType === "Outbound" || isClickToCall) {
        console.log("second")
        outboundEndedNotify();
      } else if (isInbound || callType === "Inbound") {
        // Check if inbound call was answered
        if (inboundAnswered) {
          console.log("📞 [ASTERISK] Inbound call was answered - sending state: ended");
          inboundEndedNotify();
        } else {
          console.log("📞 [ASTERISK] Inbound call was NOT answered - sending state: missed");
          abondedCallNotify();
        }
      }

      // End chat session
      endChat();

      // Reset UI
      displayScreen("dashboard");
      setDailedNumber("");

      // Cleanup
      currentCall.current = null;
      setTimeout(() => {
        [
          "ClickToCall", "isInboundCallActive", "agentEndedInboundCall", "agentEndedOutboundCall",
          "zohoSession", "calledDeviceID", "callingDeviceID", "contactId",
          "dailedNumber", "callType", "skillset", "inboundnotifyval",
          "startTime", "formattedTime", "outboundCallAnswered", "ringStartTime", "inboundCallAnswered",
          "asteriskCallId"
        ].forEach(localStorage.removeItem.bind(localStorage));
      }, 500);
    });

    // Call failed
    BrowserPhoneSIP.on("callFailed", (error) => {
      if (!isAsteriskVoiceType()) return;

      console.log("❌ Asterisk call failed - Full error object:", error);
      console.log("🔔 [ASTERISK] Error Code:", error.errorCode, "Status Code:", error.statusCode, "Reason:", error.reasonPhrase);
      toast.error("Call failed: " + (error.reasonPhrase || error.message || "Unknown error"), toastStyle);

      // Call outboundEndedNotify with state="busy" for all rejection scenarios
      const callType = localStorage.getItem("callType");
      if (callType === "Outbound") {
        console.log("📞 [ASTERISK] Calling outgoingCallNotify with state=busy for rejected call");
        console.log("third")
        //outboundEndedNotify(null, "busy");
      }

      pauseAudio();
      getTimer.pauseTimer();
      displayScreen("dashboard");
      setDailedNumber("");

      currentCall.current = null;

      // Cleanup localStorage
      setTimeout(() => {
        [
          "ClickToCall", "isInboundCallActive", "agentEndedInboundCall", "agentEndedOutboundCall",
          "zohoSession", "calledDeviceID", "callingDeviceID", "contactId",
          "dailedNumber", "callType", "skillset", "inboundnotifyval",
          "startTime", "formattedTime", "outboundCallAnswered", "ringStartTime", "inboundCallAnswered",
          "asteriskCallId"
        ].forEach(localStorage.removeItem.bind(localStorage));
      }, 500);
    });

    // Error handler
    BrowserPhoneSIP.on("error", (error) => {
      // console.error("❌ Asterisk SIP error:", error);
      toast.error("SIP connection error", toastStyle);
    });

    // Remote stream received
    BrowserPhoneSIP.on("remoteStreamReceived", (stream) => {
      if (!isAsteriskVoiceType()) return;
      // console.log("🎵 Remote audio stream received:", stream);
    });
  };
  //  END ASTERISK SIP INTEGRATION  //

  const socketConnection = async () => {
    let lastStatusValue = null;

    // If socket already exists, don't create a new one
    if (socketRef.current && socketRef.current.connected) {
      // console.log("Socket already connected, skipping");
      return;
    }

    // Disconnect any existing socket before creating a new one
    if (socketRef.current) {
      // console.log("Disconnecting existing socket before creating new one");
      socketRef.current.disconnect();
      socketRef.current.removeAllListeners();
    }

    // console.log("SocketRunning - Creating new socket connection");
    const socket = io(`${SocketUrl}/${tenantId}`, {
      transports: ["websocket"],
      reconnection: true,              // Enable reconnection
      reconnectionDelay: 1000,         // Start with 1 second delay
      reconnectionDelayMax: 5000,      // Max 5 seconds between attempts
      reconnectionAttempts: Infinity,  // Keep trying to reconnect
      timeout: 20000,                  // Connection timeout (20s)
      pingTimeout: 60000,              // Ping timeout (60s) - server must respond within this time
      pingInterval: 25000,             // Ping every 25 seconds to keep connection alive
      autoConnect: true,               // Auto-connect on creation
      forceNew: false,                 // Reuse existing connection if available
    });

    // Store socket in ref for cleanup
    socketRef.current = socket;

    socket.on("disconnect", (reason) => {
      console.log("socket=> Disconnected, reason:", reason);
      // If disconnected due to server or transport issues, it will auto-reconnect
      // due to reconnection: true setting
    });

    socket.on("reconnect_attempt", (attemptNumber) => {
      console.log("socket=> Reconnection attempt:", attemptNumber);
    });

    socket.on("reconnect", (attemptNumber) => {
      console.log("socket=> Reconnected successfully after", attemptNumber, "attempts");

      // After reconnection, check if Asterisk needs to re-register
      if (isAsteriskVoiceType()) {
        const isRegistered = BrowserPhoneSIP.isRegistered();
        console.log("socket=> Asterisk registration status after reconnect:", isRegistered);

        if (!isRegistered) {
          console.log("socket=> Asterisk not registered, attempting to re-initialize...");
          // Re-initialize Asterisk connection after a brief delay
          setTimeout(() => {
            initializeAsteriskClient();
          }, 2000);
        }
      }
    });

    socket.on("reconnect_error", (error) => {
      console.warn("socket=> Reconnection error:", error.message);
    });

    socket.on("reconnect_failed", () => {
      console.error("socket=> Reconnection failed after all attempts");
    });

    socket.on("connect", function () {
      console.log("socket=> Connected");

      // Verify Asterisk is still registered when socket reconnects
      if (isAsteriskVoiceType()) {
        const isRegistered = BrowserPhoneSIP.isRegistered();
        if (!isRegistered) {
          console.log("socket=> Asterisk not registered on connect, re-initializing...");
          setTimeout(() => {
            initializeAsteriskClient();
          }, 1000);
        }
      }
    });
    socket.on("update-force-logout", (logoutAgent) => {
      // console.log("logoutAgent", logoutAgent)
    });
    socket.on("make-call-receive", (newcall) => {
      // Get fresh loggedInAgent data from localStorage
      const currentLoggedInAgent = JSON.parse(localStorage.getItem("avayaLogin")) || {};

      if (
        newcall.data === "Make Call" &&
        newcall.userid === currentLoggedInAgent.user_id
      ) {
        let calledNo = newcall.calledno;
        let isValid = false;

        // Normalize if it starts with +
        if (/^\+/.test(calledNo)) {
          if (/^\+(971|91|90)[0-9]+$/.test(calledNo)) {
            calledNo = calledNo.substring(1); // remove +
            isValid = true;
          }
        } else if (/^(971|91|90)[0-9]+$/.test(calledNo)) {
          isValid = true;
        }

        if (isValid && calledNo.length <= 12) {
          // console.log("making_new_call", newcall);
          // Update both localStorage AND state (important for makeCall to work correctly)
          localStorage.setItem("dailedNumber", calledNo);
          setDailedNumber(calledNo);
          // Set ClickToCall flag like manual dialer does
          localStorage.setItem("ClickToCall", "true");
          makeCall("socketCall", { ...newcall, calledno: calledNo });
        } else {
          // console.warn("Invalid number, call skipped:", newcall.calledno);
          const agentNumber = (currentLoggedInAgent && currentLoggedInAgent.voiceRecord && currentLoggedInAgent.voiceRecord.avayaUserName)
            || localStorage.getItem("AvayaUsername")
            || localStorage.getItem("agentLoginTerminalId")
            || "";

          axios
            .post(
              callNotifyUrl + "/channel/clicktodialerror",
              {
                code: "invalid",
                agent_number: agentNumber,
                customer_number: newcall.calledno,
                userId: newcall.userid,
                message: "Invalid Number",
              },
              {
                headers: {
                  Authorization:
                    "Bearer " + localStorage.getItem("access_token_cognicx"),
                  "Content-Type": "application/json",
                  tenantId: tenantId,
                },
              }
            )
            .catch((error) => {
              // console.error("Error creating call:", error);
            });
        }
      }
    });


    socket.on("answer-call-receive", (newcall) => {
        const loggedInAgent = JSON.parse(localStorage.getItem("avayaLogin")) || {};
      console.log("answer-call-receive",newcall)
      console.log("loggedInAgent.user_id",loggedInAgent.user_id)
      if (
        newcall.data == "Answer Call" &&
        newcall.userid === loggedInAgent.user_id
      ) {
        
        console.log("answer_call", newcall);
        answerIncCall();
        console.log("inboundAnsweredNotify3")
        //inboundAnsweredNotify();
        localStorage.setItem("isInboundCallActive", true);
      }
    });

    socket.on("unmute-call-receive", (newcall) => {
        const loggedInAgent = JSON.parse(localStorage.getItem("avayaLogin")) || {};
      if (
        newcall.data == "UnMute Call" &&
        newcall.userid === loggedInAgent.user_id
      ) {
        // console.log("unmute_call", newcall);
        unmute_call();
      }
    });

    socket.on("mute-call-receive", (newcall) => {
        const loggedInAgent = JSON.parse(localStorage.getItem("avayaLogin")) || {};
      if (
        newcall.data == "Mute Call" &&
        newcall.userid === loggedInAgent.user_id
      ) {
        // console.log("mute_call", newcall);
        mute_call();
      }
    });

    socket.on("hold-call-receive", (newcall) => {
        const loggedInAgent = JSON.parse(localStorage.getItem("avayaLogin")) || {};
      if (newcall.data == "Hold" && newcall.userid === loggedInAgent.user_id) {
        // console.log("hold_call", newcall);
        hold_call("customer");
      }
    });

    socket.on("unhold-call-receive", (newcall) => {
        const loggedInAgent = JSON.parse(localStorage.getItem("avayaLogin")) || {};
      if (
        newcall.data == "UnHold" &&
        newcall.userid === loggedInAgent.user_id
      ) {
        // console.log("unhold_call", newcall);
        unhold_call("customer");
      }
    });

    socket.on("end-call-receive", (newcall) => {
        const loggedInAgent = JSON.parse(localStorage.getItem("avayaLogin")) || {};
      if (
        newcall.data === "End Call" &&
        newcall.userid === loggedInAgent.user_id
      ) {
        // console.log("end_call", newcall);
        end_call();

        // For Asterisk, notifications are handled by BrowserPhoneSIP "callEnded" event
        // Only send notifications here for AACC
        if (!isAsteriskVoiceType()) {
          if (localStorage.getItem("callType") === "Outbound") {
            localStorage.setItem("agentEndedOutboundCall", "true");
            console.log("fourth")
            outboundEndedNotify();
            endChat();
          } else {
            localStorage.setItem("agentEndedInboundCall", "true");
            inboundEndedNotify();
            endChat();
          }
        }
      }
    });

    socket.on("update-agent-status-recv", (data) => {
      try {
        if (data) {
          // Get fresh loggedInAgent data from localStorage
          const currentLoggedInAgent = JSON.parse(localStorage.getItem("avayaLogin")) || {};

          if (
            data.user_id &&
            data.statusvalue !== lastStatusValue &&
            data.user_id === currentLoggedInAgent.user_id
          ) {
            lastStatusValue = data.statusvalue;
            updateStatusApi(data.statusvalue);
            setSelectedStatus(data.statusvalue);
          } else if (!data.user_id) {
            // console.error(
            //   "Error: user_id is null or undefined in the received data."
            // );
          }
        } else {
          // console.error("Error: Received data is not a valid object.", data);
        }
      } catch (error) {
        // console.error("An unexpected error occurred:", error);
      }
    });
  };

  const voicelogin = async () => {
    // Skip AACC voice login for Asterisk
    if (isAsteriskVoiceType()) {
      // console.log("⏭️ Skipping AvcUrl API for Asterisk - voicelogin");
      return;
    }

    axios
      .post(AvcUrl + `/voice/cct/agents?username=${localStorage.getItem("agentLoginTerminalId")}'`, {},
        {
          headers: {
            ssotoken: localStorage.getItem("ssoToken"),
          },
        }
      )
      .then((res) => {
        if (res.data.status = "OK") {
          localStorage.setItem("VoiceStatusLastApiCallTime", Date.now());
          setTimeout(() => {
          //  window.location.reload(true);
          }, 500);
        }
      })
      .catch((err) => {
        // console.error("Voice login error:", err);
      });
  };

  const oneHourIdleconnection = () => {
    const avayaLogin = JSON.parse(localStorage.getItem("avayaLogin") || "{}");
    const voicePlatForm = avayaLogin?.voiceRecord?.voiceType || "";

    if (voicePlatForm === "AACC" || voicePlatForm === "ACCS") {
      const checkApiCall = () => {
        const lastCallTimestamp = localStorage.getItem("VoiceStatusLastApiCallTime");
        const currentTime = Date.now();
        const oneHour = 60 * 60 * 1000;
        // const oneHour = 5 * 60 * 1000;
        // const oneHour = 1 * 60 * 1000;
        // const oneHour = 2 * 60 * 1000;

        if (!lastCallTimestamp || currentTime - lastCallTimestamp >= oneHour) {
          let getCurrentStatus = localStorage.getItem("AgentStatus");
          if (getCurrentStatus !== "Connected") {
            // console.log(
            //   "%c🚀 Voice status API call triggered after 1hr! 🚀",
            //   "color: #fff; background: #175ab6; font-size: 14px; padding: 4px 8px; border-radius: 4px;"
            // );
            voicelogin();
          }
        }
      };
      checkApiCall();
      setInterval(checkApiCall, 3600000);
      // setInterval(checkApiCall, 120000);

    }
  };

  // Asterisk SIP registration health check - monitors and maintains registration
  const asteriskHealthCheck = () => {
    const avayaLogin = JSON.parse(localStorage.getItem("avayaLogin") || "{}");
    const voicePlatForm = avayaLogin?.voiceRecord?.voiceType || "";

    // Only run health check for Asterisk voice types
    if (voicePlatForm === "Asterisk" || voicePlatForm === "ASTERISK") {
      const checkRegistration = () => {
        // Check if we should be registered (user is logged in and dashboard is active)
        const dashboard = localStorage.getItem("dashboard");
        if (dashboard === "true" && avayaLogin?.user_id) {
          const isRegistered = BrowserPhoneSIP.isRegistered();

          if (!isRegistered) {
            console.warn("⚠️ Asterisk SIP registration lost, attempting to re-register...");
            // Re-initialize Asterisk client
            initializeAsteriskClient();
          } else {
            // console.log("✅ Asterisk SIP registration health check: OK");
          }
        }
      };

      // Run initial check after 5 seconds
      setTimeout(checkRegistration, 5000);

      // Then check every 2 minutes (120 seconds)
      // This complements the SIP.js automatic re-registration at 75% of expiry time
      setInterval(checkRegistration, 120000);
    }
  };


  useEffect(() => {
    // console.log("🔧 useEffect: Checking if voice client initialization needed");

    // Only initialize voice client if user is already logged in (has avayaLogin)
    const avayaLogin = JSON.parse(localStorage.getItem("avayaLogin") || "{}");
    const dashboard = localStorage.getItem("dashboard");

    if (avayaLogin && avayaLogin.user_id && dashboard === "true") {
      // console.log("✅ User already logged in, initializing voice client...");

      // Initialize Asterisk or AACC based on voiceType
      if (isAsteriskVoiceType()) {
        // console.log("🔧 Initializing Asterisk SIP client from useEffect");
        initializeAsteriskClient();
      } else {
        // console.log("🔧 Initializing AACC STOMP/WebSocket client from useEffect");
        initiateWebSocket();
        configuration();
      }
    } else {
      // console.log("⏭️ User not logged in yet, skipping voice client initialization (will initialize after login)");
    }

    // Common initializations for both (always run)
    socketConnection();
    userStatusList();
    oneHourIdleconnection();
    asteriskHealthCheck();  // Start Asterisk registration health monitoring

    // Cleanup function
    return () => {
      // console.log("🧹 Cleaning up voice client connections");

      // Always disconnect Asterisk if it exists
      if (asteriskClient.current) {
        // console.log("🧹 Disconnecting Asterisk SIP client");
        try {
          BrowserPhoneSIP.disconnect();
        } catch (error) {
          // console.warn("⚠️ Error disconnecting Asterisk:", error);
        }
        asteriskClient.current = null;
        currentCall.current = null;
      }

      // Disconnect socket.io connection
      if (socketRef.current) {
        // console.log("🧹 Disconnecting socket.io connection");
        try {
          socketRef.current.disconnect();
          socketRef.current.removeAllListeners();
          socketRef.current = null;
        } catch (error) {
          // console.warn("⚠️ Error disconnecting socket:", error);
        }
      }

      // Disconnect STOMP/WebSocket
      onDisconnectWebSocket();
    };
  }, [serverType]); // Re-run when serverType changes

  useEffect(() => {
    const storedCallLogEntries = localStorage.getItem("callLogEntries");
    if (storedCallLogEntries) {
      const parsedEntries = JSON.parse(storedCallLogEntries);
      setCallLogEntries(parsedEntries);
    } else {
      setCallLogEntries([]);
    }
  }, []);

  useEffect(() => {
    if (Dashboard) {
      const lastPage = localStorage.getItem("currentPage");
      displayScreen(lastPage || "dashboard");
    }
  }, [Dashboard, localStorage.getItem("currentPage")]);

  useEffect(() => {
    if (!localStorage.getItem("Status")) {
      setSelectedStatus("Ready");
      updateStatus("Ready");
    }
  }, []);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setTimeout(() => {
        setShowNotification(true);
        setTimeout(() => {
          setShowNotification(false);
        }, 2000);
      }, 2000);
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
  }, []);

  return (
    <>
      <div className="container-fluid" style={{ minHeight: " 100vh" }}>
        <div className="row">
          <div className="col-12">
            {loginPage && (
              <div
                className="container-fluid"
                style={{ width: "350px", minHeight: " 100vh" }}
              >
                <div className="row align-items-center justify-content-center login-div">
                  <div className="rounded p-4">
                    <form id="loginForm">
                      <div className="text-center">
                        <img
                          className="inaipi-logo"
                          src={logo}
                          style={{ height: "60px", width: "60px" }}
                        />
                        <div>
                          <h4 className="login-word">LOGIN</h4>
                        </div>
                      </div>
                      <div className="mt-3 mb-3">
                        <input
                          type="email"
                          id="username"
                          value={username}
                          className="form-control input-style w-100"
                          onChange={(e) => setUsername(e.target.value)}
                          placeholder="Username"
                          onKeyPress={handleKeyPress}
                        />
                      </div>
                      <div className="mb-3">
                        <input
                          type={isShown ? "text" : "password"}
                          className="form-control input-style w-100"
                          id="password"
                          value={password}
                          placeholder="Password"
                          onChange={(e) => setPassword(e.target.value)}
                          onKeyPress={handleKeyPress}
                        />
                        {browserName == "Chrome" ? (
                          <span className="eye_icon">
                            {eye ? (
                              <i
                                className="fa-solid fa-eye"
                                onClick={() => {
                                  togglePassword();
                                  setEye(false);
                                }}
                              ></i>
                            ) : (
                              <i
                                className="fa-solid fa-eye-slash"
                                onClick={() => togglePassword()}
                              ></i>
                            )}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>

                      <button
                        type="button"
                        id="loginButton"
                        className="btn btn-primary py-2 w-100 mb-2 login-button"
                        onClick={loginByDcc}
                      >
                        {loginSpinner ? (
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        ) : (
                          <div> Login </div>
                        )}
                      </button>
                    </form>
                    {!code && (
                      <div
                        style={{
                          alignItems: "center",
                          justifyContent: "center",
                          display: "flex",
                          marginTop: "35px",
                          fontSize: "13px",
                        }}
                      >
                        <p>
                          If you are not authorized, Please authorize.
                          <strong
                            style={{
                              color: "#007BFF",
                              cursor: "pointer",
                              fontSize: "11px",
                            }}
                            onClick={() =>
                              window.open(authorizeRoute, "_blank")
                            }
                          >
                            Click here
                          </strong>
                        </p>
                      </div>
                    )}
                    <div
                      style={{
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                        marginTop: "35px",
                      }}
                    >
                      <p>
                        Powered by <b>Inaipi</b>
                      </p>
                    </div>
                    <div
                      style={{
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                      }}
                    >
                      <img width="50" src={inaipilogo} />
                    </div>
                  </div>
                </div>
                <ToastContainer />
              </div>
            )}

            {Dashboard && (
              <div
                className="container-fluid d-flex flex-column"
                style={{
                  width: "250px",
                  minHeight: " 100vh",
                  paddingLeft: "0px",
                  paddingRight: "0px",
                }}
              >
                {/* navbar screen */}
                <div
                  style={{
                    height: "45px",
                    width: "100%",
                  }}
                >
                  <nav
                    id="navbar"
                    className="navbar navbar-expand"
                    style={{ display: "block" }}
                  >
                    {!isOnline && (
                      <div className="offline-message">
                        <span className="material-symbols-outlined">
                          wifi_off
                        </span>
                        <span className="ms-2">
                          You're offline, Please check the internet error !
                        </span>
                      </div>
                    )}
                    {isOnline && showNotification && (
                      <div className="online-message">
                        <span className="material-symbols-outlined">wifi</span>
                        <span className="ms-2">
                          You're Online ! Internet is back.
                        </span>
                      </div>
                    )}
                    <div className="d-flex">
                      <img
                        src={inaipiLogo}
                        alt=""
                        style={{ height: "30px", width: "30px" }}
                      />
                      <div>
                        <div className="nameicon ms-1" id="usernameShowing">
                          {agentUsername}
                          <div className="nameicon">
                            {(() => {
                              const avayaLogin = JSON.parse(localStorage.getItem("avayaLogin") || "{}");
                              const voiceType = avayaLogin?.voiceRecord?.voiceType;
                              if (voiceType === "ACR") {
                                return avayaLogin?.voiceRecord?.avayaUserName || localStorage.getItem("agentLoginTerminalId");
                              }
                              return localStorage.getItem("agentLoginTerminalId");
                            })()}
                          </div>
                        </div>
                      </div>

                      <div className="dropdown d-flex ms-auto mt-3 me-3">
                        <nav className="nav">
                          <ul
                            className="nav__list"
                            style={{ paddingLeft: 0, marginBottom: 0 }}
                          >
                            <div>
                              <img
                                src={statusLogo}
                                style={{
                                  position: "absolute",
                                  height: "25px",
                                  width: "25px",
                                  marginTop: "-15px",
                                }}
                                alt=""
                              />
                            </div>
                            <li className="nav__item dropdown" id="myDropdown">
                              <div
                                className="nav__link"
                                style={{ color: "#008000" }}
                              >
                                <div
                                  className={`status-dot ${getStatusDotClass(
                                    selectedStatus
                                  )}`}
                                ></div>
                              </div>
                              <ul className="dropdown__list">
                                <li className="dropdown__item">
                                  <div
                                    className="dropdown__link"
                                    value="Ready"
                                    onClick={() => {
                                      changeStatusNew("Ready", false);
                                      updateStatus("Ready");
                                      updateStatusApi("Ready");
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      marginLeft: "-30px",
                                    }}
                                  >
                                    Ready
                                  </div>
                                </li>

                                <li className="dropdown__item submenu">
                                  <div
                                    className="dropdown__link"
                                    value="Not Ready"
                                    style={{
                                      cursor: "pointer",
                                      marginLeft: "-30px",
                                    }}
                                    onClick={() => {
                                      userStatusList();
                                      changeStatusNew("Not Ready", false);
                                      updateStatus("Not Ready");
                                      updateStatusApi("Not Ready");
                                    }}
                                  >
                                    Not Ready &#x25B8;
                                  </div>

                                  <ul className="submenu__list">
                                    {userStatus.map((item, index) => (
                                      <li key={index} className="submenu__item">
                                        <div
                                          className="submenu__link"
                                          value={item.statusName}
                                          style={{
                                            cursor: "pointer",
                                            marginLeft: "-30px",
                                          }}
                                          onClick={() => {
                                            changeStatusNew(item.statusName, false);
                                            updateStatus(item.statusName);
                                            updateStatusApi(item.statusName);
                                          }}
                                        >
                                          {item.statusName}
                                        </div>
                                      </li>
                                    ))}
                                  </ul>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </nav>
                      </div>

                      <div className="ms-2" onClick={() => {
                        changeStatusNew("Connected", true);
                        updateStatusApi("Connected");
                        setTimeout(() => {
                          logoutByDomainFirst();
                        }, 1000);
                      }}>
                        <i
                          className="fa-solid fa-arrow-right-from-bracket"
                          style={{
                            cursor: "pointer",
                            color: "blue",
                            marginRight: "5px",
                          }}
                        ></i>
                      </div>
                    </div>
                    <ToastContainer />
                  </nav>
                </div>

                {/* dashboard screen */}
                <div
                  id="dashboard"
                  style={{
                    display: "block",
                    width: "100%",
                    flexGrow: 1,
                    paddingTop: "10px",
                  }}
                >
                  <div className="input-group">
                    <input
                      type="text"
                      id="myInput"
                      className="form-control bg-light"
                      placeholder="Enter a number"
                      aria-label="Username"
                      aria-describedby="addon-wrapping"
                      value={dailedNumber}
                      onChange={handleInputChange}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") {
                          makeCall("normalcall");
                        }
                      }}
                      style={{ fontFamily: "Montserrat" }}
                    />
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <span
                        className="material-symbols-outlined"
                        style={{
                          color: "rgb(15, 228, 15)",
                          cursor: "pointer",
                        }}
                        onClick={() => makeCall("normalcall")}
                        id="makeCall"
                      >
                        call
                      </span>
                    </span>
                  </div>

                  <div className="d-flex">
                    <b className="details-box mt-2">Dialer</b>
                    <div className="dropdown  ms-auto mt-1">
                      <button
                        className="btn btn-light dropdown-toggle"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        style={{
                          fontWeight: "bolder",
                          fontSize: "10px",
                          color: "black",
                        }}
                      >
                        All
                      </button>
                      <ul className="dropdown-menu">
                        <li>
                          <a className="dropdown-item" href="#">
                            ...
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="#">
                            ...
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="#">
                            ...
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="dailer_card">
                    <div className="phone">
                      <div className="phone-container">
                        <div className="keyboard p-2">
                          <div className="number row row-cols-3">
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9, "*", 0, "#"].map(
                              (num, index) => (
                                <div
                                  key={index}
                                  data-number={num}
                                  id={
                                    num === "*"
                                      ? "astrick"
                                      : num === "#"
                                        ? "hash"
                                        : num
                                  }
                                  value={num}
                                  onClick={() => handleNumberClick(num)}
                                >
                                  <div className="number-sub">
                                    {num}
                                    {typeof num === "number" && (
                                      <span className="number-sub-value">
                                        {num === 2
                                          ? "ABC"
                                          : num === 3
                                            ? "DEF"
                                            : num === 4
                                              ? "GHI"
                                              : num === 5
                                                ? "JKL"
                                                : num === 6
                                                  ? "MNO"
                                                  : num === 7
                                                    ? "PQRS"
                                                    : num === 8
                                                      ? "TUV"
                                                      : num === 9
                                                        ? "WXYZ"
                                                        : ""}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              )
                            )}
                            <div></div>
                            <div id="make-call-from-dialer">
                              <div
                                className="number-sub"
                                style={{
                                  background: "#2E7D32",
                                  color: "white",
                                }}
                              >
                                <span
                                  className="material-symbols-outlined"
                                  onClick={() => makeCall("normalcall")}
                                >
                                  call
                                </span>
                              </div>
                            </div>
                            <div id="clear-dialer-number">
                              <div
                                className="number-sub"
                                onClick={() =>
                                  setDailedNumber((currentNumber) =>
                                    currentNumber.slice(
                                      0,
                                      currentNumber.length - 1
                                    )
                                  )
                                }
                              >
                                <span className="material-symbols-outlined">
                                  keyboard_backspace
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* call logs screen */}
                <div
                  id="callLogsScreen"
                  style={{
                    display: "block",
                    flexGrow: 1,
                  }}
                >
                  <div style={{ height: "83vh" }}>
                    <div style={{ height: "100%" }}>
                      <div className="text-center">
                        <span className="calllogs-recents border-bottom">
                          Recent call lists
                        </span>
                      </div>
                      <div
                        className="call-logs-scroll p-2"
                        id="calllogs"
                        style={{
                          overflowY: "scroll",
                          height: "100%",
                        }}
                      >
                        {callLogEntries.map((entry, index) => (
                          <div
                            key={index}
                            dangerouslySetInnerHTML={{ __html: entry }}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bottom-navbar">
                  <div className="d-flex align-items-center justify-content-center">
                    <div className="nav-item mx-3 me-3">
                      <div
                        className={
                          routeScreen == "dashboard"
                            ? "nav-link active d-flex flex-column"
                            : "nav-link d-flex flex-column"
                        }
                        aria-current="page"
                      >
                        <i
                          className="fa-solid fa-house"
                          onClick={() => displayScreen("dashboard")}
                          style={{ cursor: "pointer" }}
                        ></i>
                        Analytics
                      </div>
                    </div>
                    <div className="nav-item me-2">
                      <div
                        className={
                          routeScreen == "callLogsScreen"
                            ? "nav-link active d-flex flex-column"
                            : "nav-link d-flex flex-column"
                        }
                        aria-current="page"
                      >
                        <i
                          className="fa-solid fa-phone"
                          onClick={() => displayScreen("callLogsScreen")}
                          style={{ cursor: "pointer" }}
                        ></i>
                        Call Logs
                      </div>
                    </div>
                  </div>
                </div>

                {/* Outbound Call Attend Screen */}
                <div
                  id="outboundAnsScreen"
                  style={{
                    display: "none",
                    position: "absolute",
                    backgroundColor: "#ffff",
                    height: "100%",
                    width: "250px",
                  }}
                >
                  <div className="outgoing-dialpad ms-1 text-center">
                    <div className="called-name mt-4">
                      <img
                        src={person}
                        alt="Caller Avatar"
                        className="avatar"
                        style={{ height: "70px", width: "70px" }}
                      />

                      <div className="mt-2">
                        <p id="outgoingNumber" className="mt-2">
                          {localStorage.getItem("dailedNumber")}
                        </p>
                      </div>

                      <div className="d-flex justify-content-center">
                        {getTimer.time ? formatTime(getTimer.time.hr, getTimer.time.min, getTimer.time.sec) : "00:00"}
                      </div>
                    </div>

                    <div
                      className="d-flex justify-content-center ms-1"
                      style={{ marginTop: "140px" }}
                    >
                      <div
                        className="p-2 text-center mx-1 mt-1 function-button mute"
                        style={{ cursor: "pointer", display: "block" }}
                        onClick={mute_call}
                      >
                        <span className="material-symbols-outlined">mic</span>
                        <p className="callicon">Mute</p>
                      </div>
                      <div
                        className="p-2 text-center mx-1 mt-1 function-button unmute"
                        style={{ cursor: "pointer", display: "none" }}
                        onClick={unmute_call}
                      >
                        <span className="material-symbols-outlined">
                          mic_off
                        </span>
                        <p className="callicon">UnMute</p>
                      </div>
                      <div
                        id="hold"
                        className="p-2 text-center mx-2 mt-1 function-button hold"
                        style={{ cursor: "pointer", display: "block" }}
                        onClick={() => hold_call("customer")}
                      >
                        <span className="material-symbols-outlined">
                          pause_circle
                        </span>
                        <p className="callicon">hold</p>
                      </div>

                      <div
                        id="unhold"
                        className="p-2 text-center mx-2 mt-1 function-button unhold"
                        style={{ cursor: "pointer", display: "none" }}
                        onClick={() => unhold_call("customer")}
                      >
                        <span className="material-symbols-outlined">
                          stop_circle
                        </span>
                        <p className="callicon">Unhold</p>
                      </div>

                      <div
                        id="transfer"
                        className="p-2 text-center mx-1 mt-1 function-button"
                        style={{ cursor: "not-allowed", display: "block", opacity: 0.6 }}
                      // onClick={showdialer}
                      >
                        <span className="material-symbols-outlined">
                          phone_forwarded
                        </span>
                        <p className="callicon">Transfer</p>
                      </div>
                      <div
                        id="conferance"
                        className="p-2 text-center mx-1 mt-1 function-button"
                        style={{ cursor: "not-allowed", display: "block", opacity: 0.6 }}
                      // onClick={showdialer2}
                      >
                        <span className="material-symbols-outlined">
                          add_call
                        </span>
                        <p className="callicon">AddCall</p>
                      </div>
                    </div>

                    <div
                      className="called-name"
                      style={{ cursor: "pointer", marginTop: "30px" }}
                    >
                      <button
                        type="button"
                        onClick={end_call}
                        className="End-button btn btn-danger"
                        style={{
                          width: "55px",
                          height: "55px",
                          borderRadius: "100%",
                        }}
                      >
                        <span className="material-symbols-outlined my-2">
                          call_end
                        </span>
                      </button>
                    </div>
                  </div>
                </div>

                {/* Inbound Screen */}
                <div
                  id="incomingScreen"
                  style={{
                    display: "none",
                    position: "absolute",
                    backgroundColor: "#ffff",
                    height: "100%",
                    width: "250px",
                  }}
                >
                  <div className="outgoing-dialpad py-3 ms-1 text-center">
                    <div className="called-name mt-3">
                      <img
                        src={person}
                        alt="Caller Avatar"
                        className="avatar"
                        style={{ height: "70px", width: "70px" }}
                      />

                      <p id="incommingNumber" className="mt-2">
                        +
                      </p>

                      <p>Incoming Call</p>
                    </div>
                  </div>

                  <div
                    className="d-flex justify-content-center ms-1"
                    style={{ marginTop: "140px" }}
                  >
                    <div
                      onClick={() => {
                        answerIncCall();
                        // console.log("inboundAnsweredNotify4")
                        // inboundAnsweredNotify();
                        localStorage.setItem("isInboundCallActive", true);
                      }}
                      className="incomingcall p-2 text-center mx-3"
                      style={{
                        cursor: "pointer",
                        backgroundColor: "#4db359",
                      }}
                    >
                      <span
                        className="material-symbols-outlined mt-1"
                        style={{ color: "white" }}
                      >
                        call
                      </span>
                    </div>

                    <div
                      id="openUrlButton"
                      className="incomingcall p-2 text-center mx-3"
                      onClick={URLopen}
                      style={{
                        cursor: "pointer",
                        backgroundColor: "#f7f6fc",
                      }}
                    >
                      <img
                        src={crmlogo}
                        alt=""
                        style={{
                          height: "25px",
                          width: "25px",
                          borderRadius: "50%",
                          marginTop: "5px",
                          marginLeft: "1px",
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* Inbound Call Attend Screen */}
                <div
                  id="incomingAnsScreen"
                  style={{
                    display: "none",
                    position: "absolute",
                    backgroundColor: "#ffff",
                    height: "100%",
                    width: "250px",
                  }}
                >
                  <div className="outgoing-dialpad ms-1 text-center">
                    <div className="called-name mt-4">
                      <img
                        src={person}
                        alt="Caller Avatar"
                        className="avatar"
                        style={{ height: "70px", width: "70px" }}
                      />

                      <div className="mt-2">
                        <p id="incommingNumber2" className="mt-2"></p>
                      </div>

                      <div className="d-flex justify-content-center">
                        {getTimer.time ? formatTime(getTimer.time.hr, getTimer.time.min, getTimer.time.sec) : "00:00"}
                      </div>
                    </div>

                    <div
                      className="d-flex justify-content-center ms-1"
                      style={{ marginTop: "140px" }}
                    >
                      <div
                        className="p-2 text-center mx-1 mt-1 function-button mute"
                        style={{ cursor: "pointer", display: "block" }}
                        onClick={mute_call}
                      >
                        <span className="material-symbols-outlined">mic</span>
                        <p className="callicon">Mute</p>
                      </div>
                      <div
                        className="p-2 text-center mx-1 mt-1 function-button unmute"
                        style={{ cursor: "pointer", display: "none" }}
                        onClick={unmute_call}
                      >
                        <span className="material-symbols-outlined">
                          mic_off
                        </span>
                        <p className="callicon">UnMute</p>
                      </div>
                      <div
                        id="hold"
                        className="p-2 text-center mx-2 mt-1 function-button hold"
                        style={{ cursor: "pointer", display: "block" }}
                        onClick={() => hold_call("customer")}
                      >
                        <span className="material-symbols-outlined">
                          pause_circle
                        </span>
                        <p className="callicon">hold</p>
                      </div>

                      <div
                        id="unhold"
                        className="p-2 text-center mx-2 mt-1 function-button unhold"
                        style={{ cursor: "pointer", display: "none" }}
                        onClick={() => unhold_call("customer")}
                      >
                        <span className="material-symbols-outlined">
                          stop_circle
                        </span>
                        <p className="callicon">Unhold</p>
                      </div>

                      <div
                        id="transfer"
                        className="p-2 text-center mx-1 mt-1 function-button"
                        style={{ cursor: "not-allowed", display: "block", opacity: 0.6 }}
                      // onClick={showdialer}
                      >
                        <span className="material-symbols-outlined">phone_forwarded</span>
                        <p className="callicon">Transfer</p>
                      </div>

                      <div
                        id="conferance"
                        className="p-2 text-center mx-1 mt-1 function-button"
                        style={{ cursor: "not-allowed", display: "block", opacity: 0.6 }}
                      // onClick={showdialer2}
                      >
                        <span className="material-symbols-outlined">add_call</span>
                        <p className="callicon">AddCall</p>
                      </div>

                    </div>

                    <div
                      className="called-name"
                      style={{ cursor: "pointer", marginTop: "30px" }}
                      onClick={end_call}
                    >
                      <button
                        type="button"
                        className="End-button btn btn-danger"
                        style={{
                          width: "55px",
                          height: "55px",
                          borderRadius: "100%",
                        }}
                      >
                        <span className="material-symbols-outlined my-2">
                          call_end
                        </span>
                      </button>
                    </div>
                  </div>
                </div>

                {/* transferScreen */}
                <div
                  id="transferScreen"
                  style={{
                    display: "none",
                    position: "absolute",
                    backgroundColor: "#ffff",
                  }}
                >
                  <div className="outgoing-dialpad ms-1 border-bottom text-center my-3">
                    <div className="called-name mt-4">
                      <img
                        src={person}
                        alt="Caller Avatar"
                        className="avatar"
                        style={{ height: "40px", width: "40px" }}
                      />

                      <div className="mt-2">
                        <p id="incommingAttendNumber" className="mt-2">
                          {storedAgentNum}
                        </p>
                      </div>

                      <div className="d-flex justify-content-center">
                        <p className="hours_inc">00:</p>
                        <p className="mins_inc">00:</p>
                        <p className="seconds_inc">00</p>
                      </div>
                    </div>

                    <div className="d-flex justify-content-center ms-1">
                      <div
                        id="hold"
                        className="p-2 text-center mx-2 mt-1 function-button hold"
                        style={{ cursor: "pointer", display: "block" }}
                        onClick={() => hold_call("customer")}
                      >
                        <span className="material-symbols-outlined">
                          pause_circle
                        </span>
                        <p className="callicon">hold</p>
                      </div>

                      <div
                        id="unhold"
                        className="p-2 text-center mx-2 mt-1 function-button unhold"
                        style={{ cursor: "pointer", display: "none" }}
                        onClick={() => unhold_call("customer")}
                      >
                        <span className="material-symbols-outlined">
                          stop_circle
                        </span>
                        <p className="callicon">Unhold</p>
                      </div>

                      <div
                        id="maketransfer"
                        className="p-2 text-center mx-1 mt-1 function-button"
                        style={{ cursor: "pointer", display: "block" }}
                        onClick={makeTransferCall}
                      >
                        <span className="material-symbols-outlined">
                          phone_forwarded
                        </span>
                        <p className="callicon">Transfer</p>
                      </div>
                    </div>

                    <div
                      className="called-name"
                      style={{ cursor: "pointer" }}
                      onClick={end_call}
                    >
                      <button
                        type="button"
                        className="End-button btn mb-3 btn-danger"
                        style={{
                          width: "48px",
                          height: "48px",
                          borderRadius: "100%",
                        }}
                      >
                        <span className="material-symbols-outlined mt-1 me-4">
                          call_end
                        </span>
                      </button>
                    </div>
                  </div>
                  <div className="outgoing-dialpad ms-1 border-bottom text-center">
                    <div className="called-name mt-4">
                      <img
                        src={person}
                        alt="Caller Avatar"
                        className="avatar"
                        style={{ height: "40px", width: "40px" }}
                      />

                      <div className="mt-2">
                        <p id="Agentnumber" className="mt-2">
                          {agenttransfernum}
                        </p>
                      </div>
                    </div>

                    <div className="d-flex justify-content-center ms-1">
                      <div
                        id="agenthold"
                        className="p-2 text-center mx-2 mt-1 function-button agenthold"
                        style={{ cursor: "pointer", display: "block" }}
                        onClick={() => hold_call("agent")}
                      >
                        <span className="material-symbols-outlined">
                          pause_circle
                        </span>
                        <p className="callicon">hold</p>
                      </div>

                      <div
                        id="agentunhold "
                        className="p-2 text-center mx-2 mt-1 function-button agentunhold"
                        style={{ cursor: "pointer", display: "none" }}
                        onClick={() => unhold_call("agent")}
                      >
                        <span className="material-symbols-outlined">
                          stop_circle
                        </span>
                        <p className="callicon">Unhold</p>
                      </div>
                    </div>

                    <div
                      className="called-name"
                      style={{ cursor: "pointer" }}
                      onClick={() => end_call("transfer")}
                    >
                      <button
                        type="button"
                        className="End-button btn mb-3 btn-danger"
                        style={{
                          width: "48px",
                          height: "48px",
                          borderRadius: "100%",
                        }}
                      >
                        <span className="material-symbols-outlined mt-1 me-4">
                          call_end
                        </span>
                      </button>
                    </div>
                  </div>
                </div>

                {/* conferanceScreen */}
                <div
                  id="conferanceScreen"
                  style={{
                    display: "none",
                    position: "absolute",
                    backgroundColor: "#ffff",
                  }}
                >
                  <div className="outgoing-dialpad ms-1 border-bottom text-center">
                    <div className="called-name mt-4">
                      <img
                        src={person}
                        alt="Caller Avatar"
                        className="avatar"
                        style={{ height: "40px", width: "40px" }}
                      />

                      <div className="mt-2">
                        <p id="incommingAttendNumber" className="mt-2">
                          {storedConferAgentNum}
                        </p>
                      </div>

                      <div className="d-flex justify-content-center">
                        <p className="hours_inc">00:</p>
                        <p className="mins_inc">00:</p>
                        <p className="seconds_inc">00</p>
                      </div>
                    </div>

                    <div className="d-flex justify-content-center ms-1">
                      <div
                        id="hold"
                        className="p-2 text-center mx-2 mt-1 function-button"
                        style={{ cursor: "pointer", display: "block" }}
                        onClick={() => hold_call("customer")}
                      >
                        <span className="material-symbols-outlined">
                          pause_circle
                        </span>
                        <p className="callicon">hold</p>
                      </div>

                      <div
                        id="unhold"
                        className="p-2 text-center mx-2 mt-1 function-button"
                        style={{ cursor: "pointer", display: "none" }}
                        onClick={() => unhold_call("customer")}
                      >
                        <span className="material-symbols-outlined">
                          stop_circle
                        </span>
                        <p className="callicon">Unhold</p>
                      </div>

                      <div
                        id="makeconferance"
                        className="p-2 text-center mx-1 mt-1 function-button"
                        style={{ cursor: "pointer", display: "block" }}
                        onClick={mergeCall}
                      >
                        <span className="material-symbols-outlined">merge</span>
                        <p className="callicon">Merge</p>
                      </div>
                    </div>

                    <div className="called-name" style={{ cursor: "pointer" }}>
                      <button
                        type="button"
                        onClick={end_call}
                        className="End-button btn mb-3 btn-danger"
                        style={{
                          width: "48px",
                          height: "48px",
                          borderRadius: "100%",
                        }}
                      >
                        <span className="material-symbols-outlined mt-1 me-4">
                          call_end
                        </span>
                      </button>
                    </div>
                  </div>
                  <div className="outgoing-dialpad ms-1 border-bottom text-center">
                    <div className="called-name mt-4">
                      <img
                        src={person}
                        alt="Caller Avatar"
                        className="avatar"
                        style={{ height: "40px", width: "40px" }}
                      />

                      <div className="mt-2">
                        <p id="Agentnumber2" className="mt-2">
                          {agentconfnum}
                        </p>
                      </div>
                    </div>

                    <div className="d-flex justify-content-center ms-1">
                      <div
                        id="hold"
                        className="p-2 text-center mx-2 mt-1 function-button"
                        style={{ cursor: "pointer", display: "block" }}
                        onClick={() => hold_call("agent")}
                      >
                        <span className="material-symbols-outlined">
                          pause_circle
                        </span>
                        <p className="callicon">hold</p>
                      </div>

                      <div
                        id="unhold"
                        className="p-2 text-center mx-2 mt-1 function-button"
                        style={{ cursor: "pointer", display: "none" }}
                        onClick={() => unhold_call("agent")}
                      >
                        <span className="material-symbols-outlined">
                          stop_circle
                        </span>
                        <p className="callicon">Unhold</p>
                      </div>
                    </div>

                    <div className="called-name" style={{ cursor: "pointer" }}>
                      <button
                        type="button"
                        onClick={() => end_call("transfer")}
                        className="End-button btn mb-3 btn-danger"
                        style={{
                          width: "48px",
                          height: "48px",
                          borderRadius: "100%",
                        }}
                      >
                        <span className="material-symbols-outlined mt-1 me-4">
                          call_end
                        </span>
                      </button>
                    </div>
                  </div>
                </div>

                {/* InconferanceScreen */}
                <div
                  id="InconferanceScreen"
                  style={{
                    display: "none",
                    position: "absolute",
                    backgroundColor: "#ffff",
                  }}
                >
                  <div className="outgoing-dialpad ms-1 text-center">
                    <div className="called-name mt-4">
                      <img
                        src={person}
                        alt="Caller Avatar"
                        className="avatar"
                        style={{ height: "70px", width: "70px" }}
                      />

                      <div className="mt-2">
                        <p className="mt-2">Conferance Call...</p>
                      </div>

                      <div className="d-flex justify-content-center">
                        <p className="hours_inc">00:</p>
                        <p className="mins_inc">00:</p>
                        <p className="seconds_inc">00</p>
                      </div>
                    </div>

                    <div
                      className="called-name"
                      style={{
                        cursor: "pointer",
                        marginTop: "250px",
                        marginTop: "230px",
                      }}
                      onClick={end_call}
                    >
                      <button
                        type="button"
                        className="End-button btn btn-danger"
                        style={{
                          width: "55px",
                          height: "55px",
                          borderRadius: "100%",
                        }}
                      >
                        <span className="material-symbols-outlined my-2">
                          call_end
                        </span>
                      </button>
                    </div>
                  </div>
                </div>

                {/* {Dialer}  */}
                <Draggable>
                  <div
                    className="dialer-pad animate__animated animate__fadeInLeft"
                    id="dialer"
                    style={{
                      display: "none",
                      position: "absolute",
                      backgroundColor: "#ffff",
                    }}
                  >
                    <div className="display1">{input}</div>
                    <div className="button-row">
                      <button onClick={() => handleButtonClick("1")}>1</button>
                      <button onClick={() => handleButtonClick("2")}>2</button>
                      <button onClick={() => handleButtonClick("3")}>3</button>
                    </div>
                    <div className="button-row">
                      <button onClick={() => handleButtonClick("4")}>4</button>
                      <button onClick={() => handleButtonClick("5")}>5</button>
                      <button onClick={() => handleButtonClick("6")}>6</button>
                    </div>
                    <div className="button-row">
                      <button onClick={() => handleButtonClick("7")}>7</button>
                      <button onClick={() => handleButtonClick("8")}>8</button>
                      <button onClick={() => handleButtonClick("9")}>9</button>
                    </div>
                    <div className="button-row">
                      <button onClick={() => handleButtonClick("*")}>*</button>
                      <button onClick={() => handleButtonClick("0")}>0</button>
                      <button onClick={() => handleButtonClick("#")}>#</button>
                    </div>
                    <div className="button-row">
                      <button onClick={closedialer}>
                        <i className="fa-regular fa-circle-xmark"></i>
                      </button>
                      <div className="call" onClick={making_transfer_call}>
                        <i className="fa-solid fa-phone"></i>
                      </div>
                      <button onClick={handleClear}>
                        <i className="fa-solid fa-delete-left"></i>
                      </button>
                    </div>
                  </div>
                </Draggable>

                {/* {Dialer2}  */}
                <Draggable>
                  <div
                    className="dialer-pad2 animate__animated animate__fadeInLeft"
                    id="dialer2"
                    style={{
                      display: "none",
                      position: "absolute",
                      backgroundColor: "#ffff",
                    }}
                  >
                    <div className="display2">{input}</div>
                    <div className="button-row2">
                      <button onClick={() => handleButtonClick("1")}>1</button>
                      <button onClick={() => handleButtonClick("2")}>2</button>
                      <button onClick={() => handleButtonClick("3")}>3</button>
                    </div>
                    <div className="button-row2">
                      <button onClick={() => handleButtonClick("4")}>4</button>
                      <button onClick={() => handleButtonClick("5")}>5</button>
                      <button onClick={() => handleButtonClick("6")}>6</button>
                    </div>
                    <div className="button-row2">
                      <button onClick={() => handleButtonClick("7")}>7</button>
                      <button onClick={() => handleButtonClick("8")}>8</button>
                      <button onClick={() => handleButtonClick("9")}>9</button>
                    </div>
                    <div className="button-row">
                      <button onClick={() => handleButtonClick("*")}>*</button>
                      <button onClick={() => handleButtonClick("0")}>0</button>
                      <button onClick={() => handleButtonClick("#")}>#</button>
                    </div>
                    <div className="button-row2">
                      <button onClick={closedialer2}>
                        <i className="fa-regular fa-circle-xmark"></i>
                      </button>
                      <div className="call2" onClick={make_Confrence_Call}>
                        <i className="fa-solid fa-phone"></i>
                      </div>
                      <button onClick={handleClear}>
                        <i className="fa-solid fa-delete-left"></i>
                      </button>
                    </div>
                  </div>
                </Draggable>

                {isModelOpen && (
                  <>
                    <div className="modalOverlay"></div>
                    <div className="modalSameExtNum">
                      <div>
                        <p>
                          Don't Enter the Same Extension Number You Logged In!
                        </p>
                      </div>
                      <div className="modalSameExtNumBtn">
                        <button onClick={closeModal}>OK</button>
                      </div>
                    </div>
                  </>
                )}
                {isModelOpen2 && (
                  <>
                    <div className="modalOverlay"></div>
                    <div className="modalNotValidNum">
                      <div>
                        <p>Please Enter a Valid Number!</p>
                      </div>
                      <div className="modalNotValidNumBtn">
                        <button onClick={closeValidNumDiv}>OK</button>
                      </div>
                    </div>
                  </>
                )}
                {isModelOpen3 && (
                  <>
                    <div className="modalOverlay"></div>
                    <div className="modalLoginFail">
                      <div>
                        <p>LOGIN FAIL!</p>
                      </div>
                      <div className="modalLoginFailBtn">
                        <button onClick={closeLoginFailedDiv}>OK</button>
                      </div>
                    </div>
                  </>
                )}
                {isAuthorizeOpen && (
                  <>
                    <div className="modalOverlay"></div>
                    <div className="modalLoginFail">
                      <div>
                        <p>Please login to Zoho Application!</p>
                      </div>
                      <div className="modalLoginFailBtn">
                        <button
                          onClick={() => {
                            closeIaAuthorizeDiv();
                            logoutByDomainFirst();
                          }}
                        >
                          OK
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            )}

            {isModalOpenLogout && (
              <div>
                <div className="modalOverlay"></div>
                <div className="modalLoginFail">
                  <div>
                    <h6>Confirmation</h6>
                  </div>
                  <div>
                    <p>
                      Looks like you're already logged in. Sign out to switch
                      accounts
                    </p>
                  </div>
                  <div className="modalLoginFailBtn">
                    <button
                      className="btn btn-primary btn-sm"
                      onClick={handleSignout}
                    >
                      Sign Out
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}; // End of App component

export default App;
